
import { EventEmitter, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http'
import * as CryptoJS from 'crypto-js';
import jwtDecode from "jwt-decode";
import { BehaviorSubject, forkJoin, Observable, of, Subscriber, Subscription, timer, empty, Subject, throwError } from 'rxjs';
import { concatAll, first, map, subscribeOn, tap, switchMap, elementAt, catchError, finalize, shareReplay } from 'rxjs/operators';
import { SucursalEcommerce } from './interfaces/sucursales-eccomerce.interface'
import { ArticulosEcommerce } from './interfaces/articulos-ecommerce.interface';
import { Usuario } from './interfaces/usuario.interface';
import { PromocionesEccomerce } from './class/promociones-class';
import { CategoriasWebMenu, MarcasEcommerce, BackUptArticulo } from './public-api';
import { ArticulosGeneral } from './class/articulos-general.interface';
import { PorcentajePromo } from './class/porcentaje-promo.class';
import { MontoPromo } from './class/monto-calculado-promo';
import { DiferenciaPromo } from './class/diferencia-promo.class';
import { NxMPromo } from './class/nxm-promo.class';
import { ComboPromo } from './class/combo-promo.class';
import { PromoItemEcommerce } from './interfaces/promo-item.interface';
import { RemplazosMMax } from './interfaces/remplazos-ecommerce.interface';
import { ItemsMMaxResumen, PedidosMmaxEccomerce } from './interfaces/pedidos-eccomerce.interface';
import { ResultadosDeBusquedaInterface } from './interfaces/resultado-busqueda.interface';
import { ArticuloPeticionEnviar, HistorialPedidos } from './interfaces/historial-ecommerce-mmax';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { OfertasEcommerce } from './interfaces/ofertas-ecommerce.interface';
import { TagsEcommerce } from './interfaces/tags-eccomerce.interface';
import { ModalService } from 'projects/mariano-max/src/app/core/app-shared/public-api';

import { Ciudad } from './interfaces/ciudades-envío.interface';
import { TOKEN_CHECK_INTERVAL_TIME } from './constants';
import { DatosEnvio } from './interfaces/envios.interface';

import { ClienteWeb } from './interfaces/clienteweb.interface';
import { RedSocial } from './interfaces/redSocial.interface';
import { AuthService } from '../auth/auth.service';
import { OrderEstado, OrderSituacion } from './order-status.enums';
import { AppConfigService } from '../config/app-config.service';
import { ThemeService } from '../theming/theme.service';
import { IdleTimeoutService } from '../auth/idle-timeout.service';
import { CloudinaryService } from '../media/cloudinary.service';
import { CategoriesBrandsService } from '../catalog/categories-brands.service';
import { SucursalesService } from '../catalog/sucursales.service';
import { EnviosService } from '../shipping/envios.service';
import { PedidosService } from '../orders/pedidos.service';
import { CarruselPromocionesService } from '../catalog/carrusel-promociones.service';
@Injectable({
  providedIn: 'root'
})
export class EcommerceGenericoService {

  private lastObs: string;
  private token: string;
  private pdGlobal: string;
  private sucursal_defecto: string;
  private articulosSucursalDefecto: ArticulosGeneral[] = [];
  private cacheArticulosPorLista: Map<string, any[]> = new Map();
  private vistaListaActual: 'MAY' | 'CF' = 'MAY';

  private urlmap: string;
  ciudades: BehaviorSubject<any[]> = new BehaviorSubject([]);

  private environment: { endpoint: string, endpointversion } | null = null;
  private environmenturl: URL | null = null;

  private lastSearch: BehaviorSubject<ArticulosGeneral[]> = new BehaviorSubject([]);
  private minisearch: BehaviorSubject<ArticulosGeneral[]> = new BehaviorSubject([]);
  private paginadorProvider: BehaviorSubject<number> = new BehaviorSubject(1);
  private paginadorProviderOfertas: BehaviorSubject<number> = new BehaviorSubject(1);
  private promocionesEcommerce: PromocionesEccomerce[] = [];
  /**
   * Promos tipo Promocion con condicion='T' (Tipo Cliente OL): no se resuelven
   * por articulo (items[] viene vacio a proposito, no se curan en
   * ItemPromocionWeb), se aplican como % sobre el total del carrito en
   * calcularMontoDePromocionGlobalCliente(), excluyendo articulos que ya
   * tengan otro descuento (isdePromo/isdeoferta).
   */
  private promocionesGlobalTipoCliente: PorcentajePromo[] = [];
  /**
   * Promos tipo Codigo Promocional (K) que el cliente ingreso en el carrito.
   * No vienen en el listado general de promocioneswebec (el back las excluye
   * para no exponer los codigos): se piden una por una con el parametro
   * codigopromocional y se aplican igual que las globales por Tipo Cliente OL
   * (porcentaje o monto fijo sobre los articulos sin otro descuento).
   */
  private promocionesCodigoPromocional: PorcentajePromo[] = [];
  private contador: number = 0;
  private tareas: Observable<void>[] = [];
  private intervals: number[];
  private idInterval: number;
  private carritoObservables: Observable<void>[] = [];
  private idIntervalForCart: number;
  private reset: boolean;

  private resultadosDebusqueda: ArticulosGeneral[] = [];
  private numBusqueda: number;
  private paginaActual: number;
  private paginaActualOfertas: number;
  private anchoPagina: number;
  private fueBusquedaEscrita: boolean = true;

  private remplasosProvider: BehaviorSubject<RemplazosMMax[]> = new BehaviorSubject([]);
  private remplazos: RemplazosMMax[] = [];

  private mapaPedidos: Map<number, { marca: number, codigo: number, descripcion: string }[]>;
  // Ultima busqueda por categoria activa; se repite al reindexar (articulos que llegan tarde o cambio de sucursal)
  private ultimaBusquedaCategoria: { categoria: CategoriasWebMenu, categoriaPadre: CategoriasWebMenu } | null = null;
  private resultadoDeBusquedaSubject: BehaviorSubject<ResultadosDeBusquedaInterface> = new BehaviorSubject(undefined);

  private montoMinimo: number;
  private pagoDiferido: BehaviorSubject<string> = new BehaviorSubject(undefined);
  private envioHabilitado: BehaviorSubject<string> = new BehaviorSubject(undefined);
  private registroHabilitado: BehaviorSubject<string> = new BehaviorSubject(undefined);

  private imagenModal: string;

  private ofertasEnlazadas: OfertasEcommerce[] = [];
  private ofertasTemp: BehaviorSubject<OfertasEcommerce[]> = new BehaviorSubject([]);
  private ofertas: ArticulosGeneral[] = [];

  resizeObservable$: Observable<Event>;
  resizeSubscription$: Subscription;

  private tags: TagsEcommerce[] = [];
  private tagsRelacion: any[];
  private tagsActivos: Map<number, ArticulosGeneral[]> = new Map();

  private logoSvg: SafeUrl;
  private iconLogo: string;
  private nombreSitio: string = "";
  private colores: any = [];
  private oldSort: any = [];
  private busqueda: string = "";
  private filterOn: boolean = false;
  private paginaEmitter: EventEmitter<number>;
  private misPaginas: any[];
  private paginaElegida: any;
  private articuloAMostrarEnModalDeDetallesDeArticulo: ArticulosGeneral;
  private articulos2: ArticulosGeneral[] = [];
  private beneficios: BehaviorSubject<string> = new BehaviorSubject(undefined);
  private usaTurnos: BehaviorSubject<string> = new BehaviorSubject(undefined);
  private usaBultos: BehaviorSubject<string> = new BehaviorSubject(undefined);
  private usaLista: BehaviorSubject<string> = new BehaviorSubject(undefined);
  private obligaLogin: boolean;
  private horasMinimasTurno: BehaviorSubject<string> = new BehaviorSubject(undefined);
  private publicKeyMP: string = "";
  private redes: RedSocial[] = [];
  private pendingPedidos: boolean = false;
  private pendingTurnos: boolean = false;
  private pendingLogin: boolean = false;
  private pendingBeneficios: boolean = false;
  private pendingRestore: boolean = false;
  private pendingChangePass: boolean = false;
  private errorMessage: string;
  private mailAtencionAlCliente: string;
  private seRealizoUnaBusquedaSubject: BehaviorSubject<any> = new BehaviorSubject(undefined);
  private seRealizoUnaBusquedaObservable: Observable<any>;
  resultadosDebusquedaOriginales;
  private telefonoAtencionAlCliente: string;
  private numeroWhatsapp: string;
  private dataEmpresa: string;
  private articuloObservacion: ArticulosEcommerce;

  private workWithAs: string;
  private rawCategoriasArticulos: any[] = [];
  private infoProv: string;
  private retiroSucursal: string;
  private infoCompra: string;
  private infoMP: string;
  private envioExpress: boolean;
  private observacionesEnvio: string;
  private textoCerrarPedido: string;
  private terminos_condiciones: string;
  private informacion_envio: string;
  private politica_devoluciones: string;
  últimaBusquedaPorDescripcion: string;
  botonNovedades: string = "";
  terminoDeIniciarCarro: Subject<any> = new Subject();
  sePermiteAgregarArticuloACarritoSinLogin: boolean = false;
  private seAgregaronArtículosAlCarrito: Subject<string> = new Subject();
  ciudadesHabilitadasParaEnvio: Ciudad[] = [];
  private articulosSucursalCargados: Subject<string> = new Subject();
  codigoTimeoutInactividad: number = -1;
  private backUpCarritoOffline: BackUptArticulo[] = [];
  private hayCarritoOfflineRespuestaSubject: Subject<string> = new Subject();
  private sincronizandoCarritoConBack: boolean = false;
  ocultarSideBarBusqueda: boolean = true;
  ocultarMenuProductos: boolean = false;
  ocultarMenuOfertas: boolean = false;
  ocultarMenuMarcas: boolean = false;
  ocultarMenuCompras: boolean = false;
  ocultarMenuSucursales: boolean = false;
  ocultarMenuAyuda: boolean = false;
  verTutoriales: boolean = false;
  ocultarPrecio: boolean = false;
  private mostrarPreciosSinLogin: boolean = true;
  ocultarIcoMenu: boolean = false;
  mostrarMetodosPago: boolean = false;
  private menuWatermarkMensaje: string = 'V.2.2.2';
  private marcadeagua: boolean = false;
  private opacidad_marcadeagua: number = 0.2;
  private logo_empresa: string = '';
  private logingoogle: boolean = false;
  private loginCodigoMail: boolean = false;
  private mostrarNewsletter: boolean = true;

  get datosEnvio(): DatosEnvio {
    return this.enviosService.getDatosEnvio();
  }

  get codigoFlete(): string {
    return this.enviosService.getCodigoFlete();
  }

  get marcaFlete(): string {
    return this.enviosService.getMarcaFlete();
  }

  get costoUltimoFlete(): number {
    return this.enviosService.getCostoUltimoFlete();
  }

  constructor(private httpClient: HttpClient, private sanitizer: DomSanitizer, public modal: ModalService, private authService: AuthService, private appConfigService: AppConfigService, private themeService: ThemeService, private idleTimeoutService: IdleTimeoutService, private cloudinaryService: CloudinaryService, private categoriesBrandsService: CategoriesBrandsService, private sucursalesService: SucursalesService, private enviosService: EnviosService, private pedidosService: PedidosService, private carruselPromocionesService: CarruselPromocionesService, private router: Router) {

    this.seRealizoUnaBusquedaObservable = this.seRealizoUnaBusquedaSubject.asObservable();
    this.idInterval = window.setInterval( //interval cada cuanto se revisa el token del usuario
      () => { this.syncronizer() }, TOKEN_CHECK_INTERVAL_TIME);
    this.idIntervalForCart = window.setInterval(
      () => { this.cartSyncronizer() }, 1000);
    this.intervals = [this.idInterval, this.idIntervalForCart];

    // Intentar recuperar el pedido activo de localStorage
    

    this.comenzarListenerDeActividadDeOtrasTabs();
  }

  private ocultarCarrouselCategorias: boolean = false;

  getBotonNovedades() {
    return this.botonNovedades;
  }

  getOcultarCarrouselCategorias() {
    return this.ocultarCarrouselCategorias;
  }

  getLoginGoogle() {
    return this.logingoogle;
  }

  getLoginCodigoMail() {
    return this.loginCodigoMail;
  }

  getMostrarNewsletter() {
    return this.mostrarNewsletter;
  }

  initmaster = new Observable<void>(sus => {
    this.appConfigService.loadConfig().subscribe({
      next: data => {

        this.environment = this.appConfigService.getEnvironment();
        this.environmenturl = this.appConfigService.getEnvironmentUrl();
        let urlLogo = data['logo_empresa'];
        this.iconLogo = data['icono_empresa'];

        this.descargImgaen(this.cloudinaryService.conCacheBuster(urlLogo)).subscribe(data => {
          this.logoSvg = data;
        });

        this.nombreSitio = data['nombre_empresa']
        this.sucursal_defecto = data['sucursal_defecto'];
        this.colores = data['colores'];
        this.publicKeyMP = data['public_key_checkout'];
        this.dataEmpresa = data['dataEmpresa'];
        this.workWithAs = data['workWithAs'];
        this.envioExpress = data['envioExpress'];
        this.obligaLogin = data['obligaLogin'];
        this.mostrarPreciosSinLogin = data['mostrarPreciosSinLogin'] ?? true;
        this.marcadeagua = data['marcadeagua'] ?? false;
        this.opacidad_marcadeagua = data['opacidad_marcadeagua'] ?? 0.2;
        this.logo_empresa = data['logo_empresa'] || '';

        this.observacionesEnvio = data['observacion_envio'];
        this.textoCerrarPedido = data['texto_cerrar_pedido'];
        this.terminos_condiciones = data['terminos_condiciones'];
        this.informacion_envio = data['informacion_envio'];
        this.politica_devoluciones = data['politica_devoluciones'];
        this.botonNovedades = data['boton-novedades'] || "";
        this.ocultarCarrouselCategorias = data['ocultarCarrouselCategorias'] || false;

        this.infoProv = data['infoProv'];
        this.retiroSucursal = data['retiroSucursal'];
        this.infoCompra = data['infoCompra'];
        this.infoMP = data['infoMP'];
        this.ocultarIcoMenu = data['ocultarIconosMenu'];
        this.mostrarMetodosPago = data['mostrarMetodosPago'];
        this.logingoogle = data['logingoogle'] || false;
        this.loginCodigoMail = data['loginCodigoMail'] || false;
        this.mostrarNewsletter = data['mostrarNewsletter'] ?? true;

        this.redes = [];
        for (let red in data['redes']) {

          const redEnConfig = data['redes'][red];
          const nuevared: RedSocial = {
            nombre: redEnConfig['redSocialNombre'],
            link: redEnConfig['redSocialLink'],
            urlIcono: redEnConfig['redSocialUrlIcono']
          };
          this.redes.push(nuevared);
        }

        this.themeService.applyTheme(this.colores);

        this.setmailAtencionAlCliente(data['mailAtencionAlCliente']);
        this.settelefonoAtencionAlCliente(data['telefonoAtencionAlCliente']);
        this.numeroWhatsapp = data['numeroWhatsapp'] || '';

        this.ocultarMenuProductos = data['ocultarMenuProductos'];
        this.ocultarMenuOfertas = data['ocultarMenuOfertas'];
        this.ocultarMenuMarcas = data['ocultarMenuMarcas'];
        this.ocultarMenuCompras = data['ocultarMenuCompras'];
        this.ocultarMenuSucursales = data['ocultarMenuSucursales'];
        this.ocultarMenuAyuda = data['ocultarMenuAyuda'];
        this.verTutoriales = data['VerTutoriales'];

        this.configuracionEcommerce().pipe(
          switchMap(() => forkJoin([
            this.bajarSucursales(),
            //this.bajarArticulosPorSucursal(this.sucursal_defecto.toString()).toPromise(),
            this.promocioneswebs(this.sucursal_defecto.toString()).toPromise(),
            this.ofertaswebec(this.sucursal_defecto.toString()).toPromise(),
            this.barjarMarcas(),
            this.barjarCategoriasdeArticulos(),
            this.barjarCategorias(),
            // this.tagswebGet(),
            // this.tagsarticulosweb(),
            // this.inciarUsuario(),
          ]))
        ).subscribe(() => {
          this.tareasFinales().then(() => {
            sus.next();
            sus.complete();
          }).catch((err) => {
            sus.next();
            sus.complete();
          });

        }, err => this.tirarError(err, sus));
      },
    });
  }).pipe(shareReplay(1));

  async syncronizer() {
    this.contador++;
    forkJoin(this.tareas).pipe(concatAll()).subscribe(() => {

    }, (err) => {
      throw err;
    }, () => { });
  }

  async cartSyncronizer() {
    if (this.carritoObservables.length > 0) {
      this.carritoObservables[0].subscribe(() => {

      }, (err) => {
        throw err;
      }, () => {
        this.carritoObservables = [];
      });
    }

  }

  getSucursalPorNumero(sucursal: number) {
    return this.sucursalesService.getSucursalPorNumero(sucursal);
  }

  addtask(taks: Observable<void>) {
    this.tareas.push(taks);
  }

  ordenarporFechaHistorial(data: HistorialPedidos[]): HistorialPedidos[] {
    let arrayHistorial = data.sort(
      (a: HistorialPedidos, b: HistorialPedidos): number => {
        return b.iddocumento - a.iddocumento;
      }
    );

    if (arrayHistorial.length > 30) {
      arrayHistorial = arrayHistorial.slice(0, 30);
    }
    return arrayHistorial;
  }

  mayorAmenorPrecio = (a: ArticulosGeneral, b: ArticulosGeneral): number => {
    let precioArticuloA = a.getPrecio();
    let precioArticuloB = b.getPrecio();
    if (a.isdeOferta()) {
      precioArticuloA = a.getPrecioOferta();
    }

    if (b.isdeOferta()) {
      precioArticuloB = b.getPrecioOferta();
    }

    return (precioArticuloA - precioArticuloB) * -1;
  }

  menorAmayorPrecio = (a: ArticulosGeneral, b: ArticulosGeneral): number => {
    let precioArticuloA = a.getPrecio();
    let precioArticuloB = b.getPrecio();
    if (a.isdeOferta()) {
      precioArticuloA = a.getPrecioOferta();
    }

    if (b.isdeOferta()) {
      precioArticuloB = b.getPrecioOferta();
    }

    return (precioArticuloA - precioArticuloB);
  }

  ordenAlfabetico = (a: ArticulosGeneral, b: ArticulosGeneral): number => {
    if (a.getDescripCion() > b.getDescripCion()) {
      return -1;
    }
    if (a.getDescripCion() < b.getDescripCion()) {
      return 1;
    }
    return 0;
  }

  ordenAlfabeticoInvertido = (a: ArticulosGeneral, b: ArticulosGeneral): number => {
    if (a.getDescripCion() > b.getDescripCion()) {
      return 1;
    }
    if (a.getDescripCion() < b.getDescripCion()) {
      return -1;
    }
    return 0;
  }

  preOrdenAlfabetico = (a, b): number => {
    if (a.descripcion > b.descripcion) {
      return 1;
    }
    if (a.descripcion < b.descripcion) {
      return -1;
    }
    return 0;
  }

  ordenarArticulosPor(id: string, filtro: any) {
    if (id === '0') {
      this.resultadosDebusqueda.sort(this.menorAmayorPrecio);
      this.paginado();
      this.filterOn = true;

      this.lastSearch.next(this.lastSearch.value);
    }
    if (id === '1') {
      this.resultadosDebusqueda.sort(this.mayorAmenorPrecio);
      this.paginado();
      this.filterOn = true;

      this.lastSearch.next(this.lastSearch.value);
    }
    if (id === 'a') {
      this.resultadosDebusqueda.sort(this.ordenAlfabeticoInvertido);
      this.paginado();
      this.filterOn = true;

      this.lastSearch.next(this.lastSearch.value);

    }
    if (id === 'z') {
      this.resultadosDebusqueda.sort(this.ordenAlfabetico);
      this.paginado();
      this.filterOn = true;

      this.lastSearch.next(this.lastSearch.value);
    }
  }

  hasFilter() {
    return this.filterOn;
  }

  setBusquedaServGenerico(busqueda) {
    this.busqueda = busqueda;
  }

  getNewToken(): Observable<any> {
    return this.httpClient.post(this.environment.endpoint + '/jwt/renew', {}, { headers: { "Authorization": this.authService.getUser().token } });


  }

  /**
   *Elimina al usuario del localstorage, del servicio y reinicia eCommerce
   */
  limpiarysalir(): void {
    this.authService.setUser(undefined);
    this.authService.logout();
    this.authService.emitSinUsuario();
    localStorage.removeItem('currentUser');
    this.resetEccomerce();
  }

  isUserTokenValid(token): boolean {
    return this.authService.isUserTokenValid(token);
  }

  cerrarPromos(): Observable<any> {
    let promocionesaGuardar: BackUptArticulo[] = [];
    //console.log('cerrarPromos promocionesEcommerce', this.promocionesEcommerce)
    this.promocionesEcommerce.forEach(k => {
      if (k.counter > 0) {
        promocionesaGuardar.push(
          {
            marca: k.getMarca(),
            codigo: k.getCodigo(),
            cantidad: k.articuloenPromo().getCantidad(),
            precio: k.getPrecio(),
            monto: k.getPrecioCalculado(),
            reemplazo: 0,
            descripcion: '',
            fraccion: 0
          }
        );

      }
    })
    if (promocionesaGuardar.length > 0) {
      //console.log('cerrarPromos promocionesaGuardar', promocionesaGuardar)
      return this.postGenericoSeguro('itempedidoweb', { articulos: promocionesaGuardar });
    }
    else {
      return of(0);
    }

  }

  deletePromosCloud(): Observable<any> {
    let promocionesaGuardar: BackUptArticulo[] = [];
    //console.log('promocionesEcommerce', this.promocionesEcommerce)
    this.promocionesEcommerce.forEach(k => {
      promocionesaGuardar.push(
        {
          marca: k.getMarca(),
          codigo: k.getCodigo(),
          cantidad: 0,
          precio: 0,
          monto: 0,
          reemplazo: 0,
          descripcion: '',
          fraccion: 0
        }
      );
    })
    if (promocionesaGuardar.length > 0) {
      return this.postGenericoSeguro('itempedidoweb', { articulos: promocionesaGuardar });
    }
    else {
      return of(0);
    }
  }


  /**
   * elimina las promos y setea la cantidad de los articulos en 0
   */
  resetEccomerce(): void {
    // El codigo promocional vale para el pedido actual: post-compra o al
    // desloguearse no tiene que quedar pegado al siguiente carrito.
    this.limpiarCodigosPromocionales();
    if (this.sucursalesService.getSucursalActiva()?.articulos) {
      this.sucursalesService.getSucursalActiva().articulos.forEach(
        articulo => {
          this.eliminarPromos(articulo);
          articulo.setCantidad(0);
          articulo.setCantidadBultos(0);//nuevo
        }
      );
    }
    if (this.authService.getUser()) {
      this.sincronizarCarritoFrontyBack();
    }
    this.enviosService.resetCostoUltimoFlete();
    this.seAgregaronArtículosAlCarrito.next('actualizar carrito')

    // Limpiamos cualquier búsqueda activa: si no se hace, mmaxhome-landpage
    // queda con isSearching=true (por resultadoDeBusquedaSubject desactualizado)
    // y al volver a la home post-compra se sigue viendo la vista de búsqueda
    // en vez del home normal (carrusel, categorías, destacados).
    this.iniciarbusqueda('');

    // Al desloguearse (limpiarysalir -> resetEccomerce) hay que volver a pedir
    // las promociones: promocioneswebs() ya limpia this.promocionesEcommerce/
    // this.promocionesGlobalTipoCliente/carrusel al arrancar, y como para acá
    // authService.getUser() ya quedo en undefined, la vuelve a pedir sin
    // clienteOL (visitante anonimo) en vez de quedarse con las que traia
    // el usuario logueado.
    const sucursalPromos = (
      this.sucursalesService.getSucursalActiva()?.sucursal ||
      this.sucursal_defecto
    )?.toString();
    if (sucursalPromos) {
      // No alcanza con refrescar this.promocionesEcommerce: hay que volver a
      // asignar cada promo a los articulos del catalogo (eliminarPromos() de
      // arriba los dejó sin promos), si no quedan sin ofertas hasta el reload.
      this.promocioneswebs(sucursalPromos).subscribe(() => this.asignarPromociones());
    }
    
    // Al resetear ecommerce, también limpiamos el pedido activo si ya no es necesario
    // Nota: A veces resetEccomerce se llama antes de terminar el flow de pago, 
    // pero usualmente queremos limpiar esto cuando el usuario vuelve a la home o cancela.
    // localStorage.removeItem('active_pedido'); 
    //this.sucursalesService.getSucursalActiva() = null;
  }

  letresetJson(): Observable<any> {
    let params = new HttpParams();
    return this.getGenericoSeguro(params, 'resetjson');
  }

  guardarpedido(pedido: PedidosMmaxEccomerce): void {
    this.pedidosService.setUltimoPedido(pedido);
    this.pedidosService.getUltimoPedido().medios.forEach(medios => {
      medios.id = this.generarid(5);
      medios.selecionado = false;
    })
  }

  verUltimoPedido(): PedidosMmaxEccomerce {
    return this.pedidosService.getUltimoPedido();
  }

  setearArticuloParaModal(articuloAMostrarEnModal: ArticulosGeneral): void {
    this.articuloAMostrarEnModalDeDetallesDeArticulo = articuloAMostrarEnModal;
  }

  returnArtOpened() {
    return this.articuloAMostrarEnModalDeDetallesDeArticulo;
  }

  returnRedes() {
    return this.redes;
  }

  devolverMediosPagos() {
    return this.pedidosService.getUltimoPedido().medios;
  }

  obtenerPlanesdemedios(mediopago: number) {
    let params = new HttpParams();
    params = params.append('documento', this.pedidosService.getUltimoPedido().iddocumento.toString());
    params = params.append('mediopago', mediopago.toString());
    return this.getGenericoSeguro(params, 'planesmediosweb');
  }

  cerrarFinaleccomerce(mediopago: number, plan: number) {
  return this.postGenericoSeguro('ordenpagoweb', {
    documento: this.pedidosService.getUltimoPedido().iddocumento,
    mediopago: mediopago,
    plan: plan,
  });
}

  getUser() {
    return this.authService.getUser();
  }

  setUser(newUserData: Usuario) {
    this.authService.setLogueado(true);
    this.authService.setUser(newUserData);
  }

  /**
   * Revisa si el tocken del usuario sigue siendo válido, si no lo es lo renueva
   */
  tokencheck = new Observable<void>(
    response => {
      if (this.authService.getUser() != undefined) {
        //console.log('tokencheck')
        if (this.isUserTokenValid(this.authService.getUser().token) == false) {
          this.getNewToken().subscribe(data => {
            localStorage.removeItem('currentUser')
            this.authService.getUser().token = data.token;
            this.authService.emitUsuarioActual();
            localStorage.setItem('currentUser', JSON.stringify({ username: this.authService.getUser().username, token: data.token }));
          })
        }
      }
      response.complete();
    }
  );

  /**
  * reinicia el contador de inactividad, si el usuario no realiza ninguna peticion en USER_INACTIVITY_MAX_TIME ms se desloguea
  */
  restartInactivityCheck() {
    this.idleTimeoutService.restart();
  }

  comenzarListenerDeActividadDeOtrasTabs() {
    // Solo comenzamos a monitorear la actividad si el token es válido
    this.idleTimeoutService.inactivityDetected$.subscribe(() => {
      // Mostrar mensaje de sesión caducada
      if (this.authService.getUser() && this.authService.getUser().token && this.isUserTokenValid(this.authService.getUser().token)) {
        alert('Tu sesión ha caducado. Por favor, inicie sesión de nuevo!');
        //console.log(this);
        this.modal.closeAll()
        this.limpiarysalir();

        // Se usa el Router en vez de window.location.href: al estar dentro de una ruta hija
        // (p. ej. checkout/finalizar) una asignación directa de hash a veces no dispara la
        // navegación y el usuario quedaba varado en la pantalla a medio cargar.
        this.router.navigateByUrl('/');
      }
    });

    window.addEventListener('storage', (storageEvent: StorageEvent) => {
      const keyAfectada = storageEvent.key;
      if (keyAfectada === 'SeActualizoCarritoEnOtraTab') {
        this.iniciarCarrito().subscribe();  // Actualizar el carrito si es necesario
      }
    });
    document.addEventListener('keydown', () => {
      this.restartInactivityCheck();
    });
    document.addEventListener('mousemove', () => {
      this.restartInactivityCheck();
    });

    document.addEventListener('mousedown', () => {
      this.restartInactivityCheck();
    });

    document.addEventListener('touchstart', () => {
      this.restartInactivityCheck();
    });

    document.addEventListener('wheel', () => {
      this.restartInactivityCheck();
    });
  }

  actualizarCarritoDeOtrasTabs() {
    let fecha = new Date()
    localStorage.setItem('SeActualizoCarritoEnOtraTab', fecha.toString());
  }

  getSucursalesProviders() {
    return this.sucursalesService.getSucursalesProvider();
  }

  pendingFalse() {
    this.pendingLogin = false;
    this.pendingBeneficios = false;
    this.pendingPedidos = false;
    this.pendingTurnos = false;
    this.pendingRestore = false;
    this.pendingChangePass = false;
  }

  loginStart(username: any, password: any) {
    let nonce = Date.now();
    let firstHash = CryptoJS.SHA256(username + ' ' + password).toString();
    let secondHash = CryptoJS.SHA256(nonce + ' ' + firstHash).toString();
    if (!this.pendingLogin) {
      this.pendingLogin = true
      return this.loginPost('/jwt/login', { usuario: username, hash: secondHash, nonce: nonce.toString() }).pipe(
        tap((data) => {
          if (data && data['error']) {
            throw new Error(data['error']);
          }
          if (!data || !data['token']) {
            throw new Error('Token no recibido del servidor');
          }

          this.pendingLogin = false;
          localStorage.setItem('currentUser', JSON.stringify({ username: username, token: data['token'] }));
          this.authService.setUser({ username: username, token: data['token'], sucursal: -1 });
        
        // Log detallado al iniciar sesión
        console.log('DEBUG: loginStart -> pdGlobal actual:', this.pdGlobal);
        
        // Solo emitimos si pdGlobal está cargado, si no, esperamos a que configuracionEcommerce lo haga.
        if (this.pdGlobal !== undefined) {
          const decodedToken: any = jwtDecode(this.authService.getUser().token);
          const empresa = decodedToken.kermetPayload?.empresa || "0";
          const esEmpresa = Number(empresa) !== 0;
          
          let pdFinalVal = this.pdGlobal.trim();
          if (pdFinalVal === 'S') {
            pdFinalVal = esEmpresa ? "E" : "S";
          }
          // Si es 'E' o 'N', se mantiene como está.
          
          this.pagoDiferido.next(pdFinalVal);
          console.log('DEBUG: loginStart -> PagoDiferido emitido:', this.pagoDiferido.value);
        }

        //this.inciarUsuario().toPromise();
        this.restoEcomerceInit();
        })
      )
    }
  }

  /**
   * Login con Google: intercambia el idToken de Google por una sesión propia contra
   * '/jwt/google-login' (recibe { googletoken }, devuelve { token, mensaje } — a diferencia de
   * '/jwt/login', no manda 'username': el usuario se obtiene decodificando el propio token).
   */
  loginConGoogle(idToken: string) {
    if (!this.pendingLogin) {
      this.pendingLogin = true;
      return this.loginPost('/jwt/google-login', { googletoken: idToken }).pipe(
        tap((data) => {
          if (data && data['mensaje']) {
            throw new Error(data['mensaje']);
          }
          if (!data || !data['token']) {
            throw new Error('Token no recibido del servidor');
          }

          const decodedToken: any = jwtDecode(data['token']);
          const username = decodedToken?.sub || decodedToken?.kermetPayload?.usuario;
          if (!username) {
            throw new Error('No se pudo obtener el usuario del token');
          }

          this.pendingLogin = false;
          localStorage.setItem('currentUser', JSON.stringify({ username, token: data['token'] }));
          this.authService.setUser({ username, token: data['token'], sucursal: -1 });

          if (this.pdGlobal !== undefined) {
            const empresa = decodedToken.kermetPayload?.empresa || "0";
            const esEmpresa = Number(empresa) !== 0;

            let pdFinalVal = this.pdGlobal.trim();
            if (pdFinalVal === 'S') {
              pdFinalVal = esEmpresa ? "E" : "S";
            }
            this.pagoDiferido.next(pdFinalVal);
          }

          this.restoEcomerceInit();
        })
      );
    }
  }

  async cambiarSucursalV2(idSucursal: string) {
    await this.postGenericoSeguro('cambiarsucursal', {
      sucursal: idSucursal.toString(),
    }).toPromise();

    let encontroSucursal = false;
    for (let sucursal of this.sucursalesService.getSucursales()) {
      if (sucursal.sucursal.toString() === idSucursal.toString()) {
        this.sucursalesService.setSucursalActiva(sucursal);
        this.authService.getUser().sucursal = sucursal.sucursal;
        this.authService.getUser().sucursalNombre = ' ' + sucursal.nombre;
        encontroSucursal = true;
        break;
      }
    }
    if (encontroSucursal) {
      this.sucursal_defecto = idSucursal;
      this.restoEcomerceInit()
    }
    else {
      console.error('No se encontro la sucursal, y no tiene datos la misma');
    }
  }

  /**
   *
   * @param idSucursal
   */
  private async restoEcomerceInit() {
    this.reset = true;
    await this.tareasFinales();
  }

  activarSucursal(id: string) {
    return new Observable<void>(subs => {
      for (let sucursal of this.sucursalesService.getSucursales()) {
        if (sucursal.sucursal.toString() === id) {
          this.sucursalesService.setSucursalActiva(sucursal);
          break;
        }
      }
      const listaMayorista = Number(this.authService.getUser()?.listamayorista || 0);

      this.bajarArticulosPorSucursal(id, listaMayorista).subscribe(data => {
        this.iniciarsucursal(data);
        subs.next();
        this.guardarSucursalUsuario(id).subscribe(data => {
          subs.complete();
        })
      })
    })
  }

  guardarSucursalUsuario(sucursalID: string) {
    return this.putGenericoSeguro('clienteweb', {
      nombre: this.authService.getUser().nombre || '',
      direccion: this.authService.getUser().direccion || '',
      telefonos: this.authService.getUser().telefonos || '',
      dni: this.authService.getUser().dni || 0,
      fechaNacimiento: this.authService.getUser().fechaNacimiento || '',
      sucursal: sucursalID,
    });
  }

  modificarDatosUsuario(nuevosDatosUsuario) {
    const datosAEnviar = {
      nombre: nuevosDatosUsuario.nombre || '',
      direccion: nuevosDatosUsuario.direccion || '',
      telefonos: nuevosDatosUsuario.telefonos || '',
      dni: nuevosDatosUsuario.dni || 0,
      ciudad: nuevosDatosUsuario.ciudad || 0,
      //fechaNacimiento: this.authService.getUser().fechaNacimiento || '',
      //sucursal: sucursalID,
    }
    return this.putGenericoSeguro('clienteweb', datosAEnviar).pipe(tap({
      next: respuesta => {
      this.authService.getUser().nombre = datosAEnviar.nombre;
        this.authService.getUser().direccion = datosAEnviar.direccion;
        this.authService.getUser().telefonos = datosAEnviar.telefonos;
        this.authService.getUser().dni = datosAEnviar.dni;
        this.authService.getUser().ciudad = datosAEnviar.ciudad;
      }
    }));
  }

  crearUsuario(username: any, dni: any, email: any, password: any, sucursal: any, nivel: any = 0): Observable<any> {
    return this.postGenerico('clienteweb', {
      nombre: username,
      direccion: "",
      telefonos: "",
      email: email,
      ciudad: "",
      dni: dni,
      fechaNacimiento: "1899-31-12",
      sucursal: sucursal,
      password: password,
      nivel: nivel
    });
  }

  pedirCambioPass(email: any): Observable<any> {
    if (!this.pendingRestore) {
      this.pendingRestore = true;
      return this.loginPost('/jwt/restore', { email: email, operacion: 'S' }).pipe(
        tap((data) => {
          this.pendingRestore = false;
        })
      );
    }
  }

  cambiarContraseña(username: any, password: any, resetId: any) {
    let nonce = Date.now();
    let firstHash = CryptoJS.SHA256(username + ' ' + password).toString();

    if (!this.pendingChangePass) {
      this.pendingChangePass = true;
      return this.loginPost('/jwt/restore', { usuario: username, hash: firstHash, nonce: nonce, resetHash: resetId.toString(), operacion: 'H' }).pipe(
        tap((data) => {
          this.pendingChangePass = false;
        })
      );
    }
  }

  restorePassMmax(username: string, password: string, resetId) {
    let nonce = Date.now();
    let firstHash = CryptoJS.SHA256(username.toLowerCase() + ' ' + password).toString();

    return this.loginPost('/jwt/restore', { usuario: username, hash: firstHash, nonce: nonce, resetHash: resetId.toString(), operacion: 'H' }).pipe(
      tap((data) => {
        //console.log("Restore MMAX:", data);
      })
    );
  }

  sendErrorMessage(err) {
    this.errorMessage = err;
  }

  getErrorMessage() {
    return this.errorMessage;
  }

  getLogo() {
    return this.logoSvg;
  }

  getNombreSitio() {
    return this.nombreSitio;
  }

  getPublicKeyMP() {
    return this.publicKeyMP;
  }

  /**
   * Obtiene el estado o situación de un pedido para mostrar al usuario.
   * Prioriza la situación logística sobre el estado técnico.
   */
  getStatusDisplay(pedido: HistorialPedidos | any): string {
    if (!pedido) return '';
    const rawStatus = (pedido.situacion || pedido.estado || '').toString().trim();
    
    // Si el valor recibido es una de las llaves del Enum (ej: "ESPERA_ENTREGA")
    // devolvemos el valor legible (ej: "Listo para retirar")
    const validatedStatus = rawStatus.toUpperCase();
    if (OrderSituacion[validatedStatus as keyof typeof OrderSituacion]) {
      return OrderSituacion[validatedStatus as keyof typeof OrderSituacion];
    }

    return rawStatus;
  }

  /**
   * Verifica si un pedido está en espera de pago.
   */
  isEnEsperaDePago(pedido: any): boolean {
    const status = (this.getStatusDisplay(pedido) || '').toLowerCase();

    // No está en espera de pago si ya está pagado o avanzado en la logística
    if (status === OrderSituacion.PAGADO.toLowerCase() || 
        status === OrderSituacion.PAGO_DIFERIDO.toLowerCase() ||
        status === OrderSituacion.PREPARACION.toLowerCase() ||
        status === OrderSituacion.ESPERA_ENTREGA.toLowerCase() ||
        status === OrderSituacion.ENTREGADO.toLowerCase()) {
      return false;
    }

    // Está en espera de pago si lo dice la situación o si tiene el estado técnico "Cerrado"
    return status === OrderSituacion.ESPERA_PAGO.toLowerCase() || pedido.estado === 'Cerrado';
  }

  /**
   * Devuelve una clase CSS basada en el estado del pedido.
   */
  getClassStatus(pedido: any): string {
    const status = (this.getStatusDisplay(pedido) || '').toLowerCase().trim();
    return status.replace(/\s+/g, '-');
  }

  tirarError = ((err, sus: Subscriber<void>) => {
    console.error('DEBUG: tirarError -> Error capturado:', err);
    this.modal.close('spinner-modal');
    this.modal.open('modal-error');
    if (sus) {
      sus.error(err);
    }
  });
  /* Elegir turno de entrega para el calendario del carrito */
  elegirturno() {

  }

  cerrarPedido(dia: number, horainicio: number, fecha: string, modo: number, ciudad?: number, barrio?: string, calle?: string, numero?: string) {
    return this.postGenericoSeguro('cerrarpedidoweb', {
      dia: dia,
      horainicio: horainicio,
      fecha: fecha,
      modo: modo,
      observacion: this.lastObs,
      ciudad: ciudad,
      barrio: barrio,
      calle: calle,
      numero: numero,
    });
  }

  cancelarPedidoWeb() {
    return this.postGenericoSeguro('cancelarpedidoweb', {}).subscribe((data) => {
      //console.log(data);
    });
  }

  setObservacion(observacion: string) {
    this.lastObs = observacion || '';
  }

  verPedido(detalle: HistorialPedidos) {
    this.pedidosService.setDetalleElegido(detalle);
    localStorage.setItem('detalle', JSON.stringify(this.pedidosService.getDetalleElegido()))
  }

  getDetalleElegido() {
    if (this.pedidosService.getDetalleElegido() == undefined) {

      return localStorage.getItem('detalle')
    } else {
      return this.pedidosService.getDetalleElegido();
    }
  }

  /**
   * Se cargan los articulos de la sucursal defecto en la sucursal activa, si hay carrito sin login habilitado, guarda el carrito en memoria
   * @param articulos los articulos a cargar en la sucursal activa
   */
  private iniciarsucursal(articulos) {
    this.backUpCarritoOffline = [];
    if (this.sucursalesService.getSucursalActiva()?.articulos) {
      // Optimizamos: Solo recorremos si sabemos que hay artículos en el carrito
      // O si la lista no es masiva.
      const articulosConCantidad = this.sucursalesService.getSucursalActiva().articulos.filter(a => {
      const cantidad = a.getCantidad ? a.getCantidad() : 0;
      const bultos = a.getCantidadBultos ? a.getCantidadBultos() : 0;
    
      return cantidad !== 0 || bultos !== 0;
    });
      
      articulosConCantidad.forEach(
        (articulo: ArticulosEcommerce) => {
          const articuloResumido: BackUptArticulo = {
            descripcion: articulo.getDescripCion(),
            marca: articulo.getMarca(),
            codigo: articulo.getCodigo(),
            cantidad: articulo.getCantidad(),
            bultos: articulo.getCantidadBultos ? articulo.getCantidadBultos() : 0,
            precio: articulo.getPrecio(),
            monto: 0,
            reemplazo: articulo.getRemplazo(),
            fraccion: articulo.getFraccion()
          };
          this.backUpCarritoOffline.push(articuloResumido);
        }
      )
    }
    if (this.sucursalesService.getSucursalActiva()) {
      this.sucursalesService.getSucursalActiva().articulos = articulos;
    }
    this.rebuildMapaPedidos();
    this.sucursalesService.emitSucursalActivaActual();

  }

  /**
   * Al cargar app se revisa si hay un usuario en el localstorage y que el token no haya expirado, despues se buscan los datos del cliente
   * @returns
   */
  inciarUsuario() {
    return new Observable<void>(obs => {
      this.authService.setUser(JSON.parse(localStorage.getItem('currentUser')));
      if (this.authService.getUser() === null) {
        this.authService.emitSinUsuario();
        obs.next();
        obs.complete();
        return;
      }
      if (!this.isUserTokenValid(this.authService.getUser().token)) {
        this.authService.emitSinUsuario();
        this.authService.logout();
        localStorage.removeItem('currentUser');
        this.authService.logout();
        obs.next();
        obs.complete();
        return;
      }

      this.obtenerdatosdeUsuario().subscribe({
        next: respuesta => {
          const clientWeb: ClienteWeb = respuesta['registros'][0];
          this.actualizarUsuario(clientWeb);
          this.tareas.push(this.tokencheck);
          obs.next();
          obs.complete();
        },
        error: err => {
          this.authService.emitSinUsuario();
          this.authService.logout();
          localStorage.removeItem('currentUser');
          obs.next();
          obs.complete();
        },
      });

    });

  }

  ofertaswebec(sucursal) {
    let httparams = new HttpParams();
    httparams = httparams.append('sucursal', sucursal);
    return this.getGenerico(httparams, 'ofertaswebec').pipe(tap(data => {
      this.ofertasEnlazadas = data['registros'] as OfertasEcommerce[];
    }));
  }

  getOfertAStemp() {
    return this.ofertasTemp.asObservable();
  }

  tagswebGet() {
    let httparams = new HttpParams();

    return this.getGenerico(httparams, 'tagsweb').pipe(tap(data => {
      let mydata = data['registros'];
      this.tags = [];
      if (mydata != undefined && Array.isArray(mydata)) {
        mydata.forEach(k => {
          this.tags.push({
            nombre: k['nombre'],
            articulos: [],
            tag: k['tag']
          });
        })
      }
    }))
  };

  tagsarticulosweb() {
    let httparams = new HttpParams();
    return this.getGenerico(httparams, 'tagsarticulosweb').pipe(tap(data => {
      this.tagsRelacion = data['registros'];
    }));
  }

  turnosdisponibles() {
    let params = new HttpParams();
    if (!this.pendingTurnos) {
      return this.getGenericoSeguro(params, 'turnosdisponibles').pipe(map(data => {
        this.pendingTurnos = false;
        return data['registros'];
      }));
    }
  }

  async tareasFinales() {
    try {
      await this.inciarUsuario().toPromise();
    } catch (error) {
      //console.log('tareasFinales inciarUsuario', error);
    }
    try {
      // Despues de inciarUsuario(): recien ahi authService.getUser().clienteol
      // queda completo (lo llena actualizarUsuario() con la Consulta Cliente Web),
      // y promocioneswebs() lo necesita para filtrar por tipoClienteOL.
      const sucursalPromos = (
        this.sucursalesService.getSucursalActiva()?.sucursal ||
        this.sucursal_defecto
      ).toString();
      await this.promocioneswebs(sucursalPromos).toPromise();
    } catch (error) {
      //console.log('tareasFinales promocioneswebs', error);
    }
    await this.restaurarCodigosPromocionales();
    try {
      const sucursal = (
        this.sucursalesService.getSucursalActiva()?.sucursal ||
        this.sucursal_defecto
      ).toString();
  
      const listaMayorista = Number(this.authService.getUser()?.listamayorista || 0);
  
      if (listaMayorista > 0) {
        this.vistaListaActual = 'MAY';
        await this.bajarArticulosPorSucursal(sucursal, listaMayorista).toPromise();
      } else {
        this.vistaListaActual = 'CF';
        await this.bajarArticulosPorSucursal(sucursal, 0).toPromise();
      }
  
    } catch (error) {
      //console.error('tareasFinales bajar_articulos error', error);
    }
    try {
      await this.ofertaswebec(this.sucursalesService.getSucursalActiva().sucursal.toString()).toPromise();
    } catch (error) {
      //console.log('tareasFinales ofertaswebec', error);
    }

    if (this.tagsRelacion != undefined && Array.isArray(this.tagsRelacion)) {
      this.tags.forEach(k => {
        for (let tag of this.tagsRelacion) {
          if (k.tag == tag.tag) {
            k.articulos.push(tag);
          }
          else {
            break;
          }
        }
      });
    }

    let articulosDeSucursalActiva: ArticulosEcommerce[] = [];
    let registro: ArticulosEcommerce;
    let imgenurl;
    this.articulosSucursalDefecto.forEach(
      articulo => {
        let remplasoss: RemplazosMMax[] = []
        this.remplazos.forEach(articulo => {
          let remplaceme = Object.assign({}, articulo)
          remplaceme.idcss = this.generarid(4);
          remplaceme.activo = false;
          remplasoss.push(remplaceme);
        });

        imgenurl = this.cloudinaryService.resolveImageUrl(articulo['foto']);

        registro = new ArticulosEcommerce(
          articulo['marca'],
          articulo['codigo'],
          articulo['precio'],
          articulo['impuestointerno'] | 0,
          articulo['precionormal'],
          articulo['cmax'],
          articulo['da'],
          articulo['descripcion'],
          articulo['unidadesxb'] | 0,
          articulo['presentacion'],
          articulo['pesoxb'] | 0,
          articulo['pesable'],
          articulo['pesableporunidad'],
          articulo['nombremarca'],
          articulo['nombrerubro'],
          articulo['nombrefamilia'],
          articulo['marcareal'],
          articulo['cantidad'],
          Array.isArray(articulo['coeficiente']) ? 1 : articulo['coeficiente'],
          articulo['preciopor'],
          Array.isArray(articulo['unidaddmedida']) ? '' : articulo['unidaddmedida'].trim(),
          articulo['cantidadmayorista'],
          articulo['preciomayorista'],
          Array.isArray(articulo['etiquetamedida']) ? '' : articulo['etiquetamedida'].trim(),
          imgenurl,
          -1,
          remplasoss || [],
          null,
          null,
          articulo['fraccion'],
          articulo['ppfraccion']
        );

        (registro as any).eslistamayorista = Number(articulo['eslistamayorista'] || 0);
        registro.setDestacado(Number(articulo['destacado']) || 0);
        registro.setInformacionAdicional(articulo['informacionadicional'] || '');

        this.tags.forEach(
          tag => {
            for (let articulo of tag.articulos) {
              if (articulo.codigo == registro.getCodigo() && articulo.marca == registro.getMarca()) {
                registro.setTag({ tag: tag.tag });

              }
            }
          }
        );

        if (registro.getDescripCion()[0] === "*") {
          let newDesc = registro.getDescripCion().slice(1);
          registro.descripcion = newDesc;
        }
        articulosDeSucursalActiva.push(registro)
      }
    );
    this.iniciarsucursal(articulosDeSucursalActiva);
    
    this.aplicarVistaListaActual();
    this.articulosSucursalCargados.next('listo');
    
    let fecha = new Date();
    this.ofertas = [];
    for (let ofertas of this.ofertasEnlazadas) {
      this.sucursalesService.getSucursalActiva().articulos.forEach(
        articulo => {
          if (articulo.getCodigo() == ofertas.codigo && articulo.getMarca() == ofertas.marca) {
            articulo.setdeOferta(ofertas);
            this.ofertas.push(articulo);
          }
        }
      );
    }
    //console.log('tareas finales ofetas', this.ofertas)
    this.ofertas = this.ofertas.filter((item, index) => {
      return this.ofertas.indexOf(item) === index;
    });

    let newOfertas1 = [];
    for (let i = 0; i < this.ofertas.length; i++) {
      const element = this.ofertas[i];
      if (element.deOferta.fechahasta > fecha.toISOString().split('T')[0]) {
        newOfertas1.push(element);
      }
    }
    this.ofertas = newOfertas1;
    this.paginadoOfertas();
    this.asignarPromociones();

    if (!this.authService.getUser()) {
      this.terminoDeIniciarCarro.next('Cargado Carro');
    }

    if (this.authService.getUser() != null) {
      let sucursales = this.getSucursales();
      // Antes se pedia sucursal si la del usuario no figuraba en el listado
      // de sucursales FISICAS (getSucursales()), pero sucursales "virtuales"
      // como Web nunca estan en ese listado -- un usuario autenticado con
      // Web ya asignada igual terminaba viendo el modal cada vez. Si ya esta
      // logueado y ya tiene una sucursal cargada en su perfil, no hay que
      // volver a pedirsela.
      const tieneSucursalAsignada = !!this.authService.getUser().sucursal;
      if (sucursales.length > 1) {
        if (!tieneSucursalAsignada) {
          if (localStorage.getItem('currentUser') != null || localStorage.getItem('currentUser') != undefined) {
            this.modal.open('sucursal-modal-1');
          }
        }
      }
      await this.iniciarCarrito().toPromise();
      this.aplicarVistaListaActual();
      this.articulosSucursalCargados.next('listo');
    }
  }

  /**
   * Actualiza los datos del usuario en servicio en base a la peticion clienteWeb
   * @param clienteWeb respuesta de /clienteweb
   * @param clienteWeb.tipousuario:tipo de usuario para el e-commerce
   * 0: Consumidor final sin privilegios,
   * 1: Clientes mayoristas,
   * 2: Clientes Paicor(no visualiza precios y ofertas),
   * 3: Otra clasificación de clientes
   */
  actualizarUsuario(clienteWeb: ClienteWeb) {
    this.authService.getUser().ciudad = clienteWeb.ciudad;
    this.authService.getUser().clienteol = clienteWeb.clienteol
    this.authService.getUser().direccion = clienteWeb.direccion.trim();
    this.authService.getUser().dni = clienteWeb.dni;
    this.authService.getUser().email = clienteWeb.email.trim();
    this.authService.getUser().empresa = clienteWeb.empresa;
    this.authService.getUser().listamayorista = Number(clienteWeb.listamayorista || 0);
    this.authService.getUser().listareducmayorista = (clienteWeb.listareducmayorista || 'N').toString().trim();
    this.authService.getUser().fechaNacimiento = clienteWeb.fechanacimiento;
    this.authService.getUser().nombre = clienteWeb.nombre.trim();
    this.authService.getUser().sucursal = clienteWeb.sucursal;
    this.authService.getUser().telefonos = clienteWeb.telefonos.trim();
    this.authService.getUser().ocultarPrecios = clienteWeb.ocultarprecios.trim();
    this.authService.getUser().sucursalEmpresa = clienteWeb.sucursalempresa;
    this.authService.getUser().tipoUsuario = clienteWeb.tipousuario.trim();


    if (this.authService.getUser().sucursal) {
      this.sucursalesService.getSucursales().forEach(
        sucursal => {
          if (this.authService.getUser().sucursal == sucursal.sucursal) {
            this.sucursalesService.setSucursalActiva(sucursal);
            this.authService.getUser().sucursalNombre = ' ' + sucursal.nombre;
            this.sucursal_defecto = this.authService.getUser().sucursal.toString();
          }
        }
      )
    }

    const globalVal = (this.pdGlobal || '').trim();
    console.log('DEBUG: actualizarUsuario -> pdGlobal actual:', globalVal);

    if (globalVal === 'S') {
      const empresaId = Number(clienteWeb.empresa || 0);
      const refinedVal = empresaId !== 0 ? "E" : "S";
      this.pagoDiferido.next(refinedVal);
      console.log('DEBUG: actualizarUsuario -> PagoDiferido refinado:', refinedVal, '(Empresa:', empresaId, ')');
    } else if (globalVal !== '') {
      this.pagoDiferido.next(globalVal);
      console.log('DEBUG: actualizarUsuario -> PagoDiferido mantenido:', globalVal);
    }
    console.log('DEBUG: actualizarUsuario final val:', this.pagoDiferido.getValue());

    this.authService.emitUsuarioActual();
  }

  obtenerdatosdeUsuario() {
    let params = new HttpParams();
    return this.getGenericoSeguro(params, 'clienteweb');

  }

  obtenerdatosdeUsuarioV2() {
    let params = new HttpParams();
    return this.getGenerico(params, 'clienteweb');

  }

  barjarMarcas() {
    let params = new HttpParams();

    return this.getGenerico(params, 'marcasweb').pipe(tap((data) => {
      const marcasDestacadas: MarcasEcommerce[] = [];
      data['registros'].forEach(element => {
        let imgenurl = this.cloudinaryService.resolveImageUrl(element['imagen']);

        marcasDestacadas.push({
          articulos: element['articulos'],
          destacada: element['destacada'],
          imagen: imgenurl,
          marca: element['marca'],
          nombre: element['nombre'],
          urlexterna: element['urlexterna'],
        })
      });
      this.categoriesBrandsService.reemplazarMarcas(marcasDestacadas);
    }));
  }

  getMarcasDestacadas() {
    return this.categoriesBrandsService.getMarcasDestacadas();
  }

  getOfertas() {
    return this.ofertas;
  }

  getNumPagOfertas() {
    return this.ofertas.length / 30;
  }

  paginadoOfertas() {
    const paginas = this.ofertas.length / 30;
    this.paginadorProviderOfertas.next(paginas);
    this.paginaActualOfertas = 0;
  }

  barjarCategorias() {
    let params = new HttpParams();

    return this.getGenerico(params, 'categoriasweb').pipe(tap(data => {
      const categoriasWeb: CategoriasWebMenu[] = [];
      data['registros'].forEach(element => {
        let imgenurl = this.cloudinaryService.resolveImageUrl(element['imagen']);

        categoriasWeb.push({
          articulos: element['articulos'],
          categoria: element['categoria'],
          imagen: imgenurl,
          nombre: element['nombre'],
          orden: element['orden'],
          padre: element['padre'],
          subCategorias: [],
          desplegado: false,
        });
      });
      this.categoriesBrandsService.reemplazarCategorias(categoriasWeb);
    }));
  }

  getExtraResultadosProvider() {
    return this.resultadoDeBusquedaSubject.asObservable();
  }

  getMovimientosMmax() {
    let params = new HttpParams();

    if (!this.pendingBeneficios) {
      this.pendingBeneficios = true;
      return this.getGenericoSeguro(params, 'ConsultaSaldo').pipe(map(data => {
        this.pendingBeneficios = false
        return data['registros'];
      }));
    }
  }

  barjarCategoriasdeArticulos() {
    let params = new HttpParams();
    return this.getGenerico(params, 'categoriasarticulosweb').pipe(tap(data => {
      this.rawCategoriasArticulos = data['registros'] || [];
      this.rebuildMapaPedidos();
    }));
  }

  private rebuildMapaPedidos() {
    if (!this.rawCategoriasArticulos || this.rawCategoriasArticulos.length === 0) return;
    
    const sucursalActiva = this.sucursalesService.getSucursalActiva();
    if (!sucursalActiva || !sucursalActiva.articulos || sucursalActiva.articulos.length === 0) {
      // console.warn('DEBUG: rebuildMapaPedidos -> No hay artículos en la sucursal para indexar.');
      return;
    }

    this.mapaPedidos = new Map();
    const seen = new Set();
    const articleIndex = new Map<string, string>();
    
    // 1. Crear el índice de artículos de la sucursal
    sucursalActiva.articulos.forEach(l => {
      articleIndex.set(`${l.getMarca()}-${l.getCodigo()}`, l.getDescripCion());
    });

    // 2. Cruzar con las categorías crudas (registros de la base de datos)
    this.rawCategoriasArticulos.forEach(k => {
      const key = `${k.marca}-${k.codigo}-${k.categoria}`;
      if (!seen.has(key)) {
        seen.add(key);
        const descripcion = articleIndex.get(`${k.marca}-${k.codigo}`);
        if (descripcion) {
          const catId = Number(k.categoria);
          if (!this.mapaPedidos.has(catId)) {
            this.mapaPedidos.set(catId, []);
          }
          this.mapaPedidos.get(catId).push({
            marca: k.marca,
            codigo: k.codigo,
            descripcion: descripcion
          });
        }
      }
    });

    // 3. Ordenar
    this.mapaPedidos.forEach(lista => lista.sort(this.preOrdenAlfabetico));

    if (this.ultimaBusquedaCategoria) {
      const { categoria, categoriaPadre } = this.ultimaBusquedaCategoria;
      this.busquedaCategoria(categoria, categoriaPadre);
    }
    // console.log(`DEBUG: rebuildMapaPedidos -> Reconstruido con ${this.mapaPedidos.size} categorías indexadas.`);
  }

  containsObject(obj, list) {
    var i;
    for (i = 0; i < list.length; i++) {
      if (list[i].marca == obj.marca && list[i].codigo == obj.codigo) {

        return true;
      }
    }

    return false;
  }

  getCategoriasWeb() {
    return this.categoriesBrandsService.getCategoriasWeb();
  }

  bajarSucursales() {
    let params = new HttpParams();
    var fundentroOtraFun = () => {
      let sucursal = this.sucursalesService.getSucursales()[0];
      if (sucursal) {
        //console.log('SE ESTABLECIO UNA SUCURSAL DEFECTO' + ' ' + sucursal.nombre);
        this.sucursal_defecto = sucursal.sucursal.toString();
        this.sucursalesService.setSucursalActiva(sucursal);
        this.sucursalesService.getSucursalActiva().articulos = [];
        this.articulosSucursalDefecto = [];
      }
    }
    return this.getGenerico(params, 'sucursalesweb').pipe(tap(data => {
      let suc = data['registros'] as any[];
      this.sucursalesService.setSucursales([]);
      //console.log('this.getGenerico(params, sucursalesweb)' ,suc)

      // Solo alertar y retornar si definitivamente no hay sucursales en la respuesta
      if (!suc || !Array.isArray(suc) || suc.length === 0) {
        alert('Sin Sucursales - Recargue la página y si presiste comuniquese con el administrador informando el error.');
        return;
      }

      let sucu: SucursalEcommerce;
      suc.forEach(sucursal => {
        // Saltar si el elemento individual está vacío, pero continuar con los demás
        if (!sucursal) return;

        sucu = sucursal as SucursalEcommerce;
        //validación defensiva
        sucu.abreviatura = (sucu.abreviatura || '').toString().trim();
        sucu.barrio = (sucu.barrio || '').toString().trim();
        sucu.calle = (sucu.calle || '').toString().trim();
        sucu.localidad = (sucu.localidad || '').toString().trim();
        sucu.nombre = (sucu.nombre || '').toString().trim();
        sucu.urlmap = (sucu.urlmap || '').toString().trim();
        sucu.telefono = (sucu.telefono || '').toString().trim();
        sucu.articulos = [];
        this.sucursalesService.getSucursales().push(sucu);
        if (sucu.sucursal.toString() === this.sucursal_defecto.toString()) {
          this.sucursalesService.setSucursalActiva(sucu);
          this.sucursalesService.getSucursalActiva().articulos = [];
        }

      })
      if (this.sucursalesService.getSucursalActiva()) {
        if (!this.sucursalesService.getSucursalActiva().articulos) {
          fundentroOtraFun()
        }
      }
      else {
        fundentroOtraFun()
      }

      this.sucursalesService.emitSucursalesActuales();
    }))
  }

  configuracionEcommerce() {
    let params = new HttpParams();
    return this.getGenerico(params, 'configuracionecommerce').pipe(tap(
      respuestaconfiguracionecommerce => {
        //console.log('usaBultos:', respuestaconfiguracionecommerce['usaBultos']);

        if (respuestaconfiguracionecommerce && respuestaconfiguracionecommerce['error']) {
          throw new Error(respuestaconfiguracionecommerce['error']);
        }
        //console.log("Configuraciones Data: ", data);
        this.sucursal_defecto = respuestaconfiguracionecommerce['sucursal'];
        //console.log("CONF",respuestaconfiguracionecommerce);

        let rempla = respuestaconfiguracionecommerce['reemplazos'] as RemplazosMMax[];
        if (rempla != undefined) {
          this.remplazos = rempla;
          this.remplasosProvider.next(this.remplazos);
        }

        this.montoMinimo = respuestaconfiguracionecommerce['montoMinimo'];
      this.pdGlobal = (respuestaconfiguracionecommerce['pagoDiferido'] || '').toString().trim();
      
      // console.log('DEBUG: configuracionEcommerce -> pdGlobal cargado:', this.pdGlobal);

      let pdFinal = this.pdGlobal;
      if (this.pdGlobal === 'S' && this.authService.getUser() && this.authService.getUser().token) {
        try {
          const decodedToken: any = jwtDecode(this.authService.getUser().token);
          const empresa = decodedToken.kermetPayload?.empresa || "0";
          pdFinal = Number(empresa) !== 0 ? 'E' : 'S';
          console.log('DEBUG: configuracionEcommerce -> PagoDiferido refinado por usuario:', pdFinal);
        } catch (e) {
          console.warn("DEBUG: Error decodificando token en config", e);
        }
      }

        this.pagoDiferido.next(pdFinal);
        //this.pagoDiferido.next(respuestaconfiguracionecommerce['pagoDiferido']);
        this.envioHabilitado.next(respuestaconfiguracionecommerce['envioHabilitado']);
        this.registroHabilitado.next(respuestaconfiguracionecommerce['registroHabilitado']);
        this.beneficios.next(respuestaconfiguracionecommerce['beneficios']);
        this.usaTurnos.next(respuestaconfiguracionecommerce['usaTurnos']);
        this.usaBultos.next(respuestaconfiguracionecommerce['usaBultos']);
        this.usaLista.next(respuestaconfiguracionecommerce['usaLista']);
        this.horasMinimasTurno.next(respuestaconfiguracionecommerce['horasMinimas']);
        this.enviosService.setFleteConfig(respuestaconfiguracionecommerce['marcaFlete'], respuestaconfiguracionecommerce['codigoFlete']);
        this.sePermiteAgregarArticuloACarritoSinLogin = (respuestaconfiguracionecommerce['carroSinLogin'] === 'S')
      }
    ));

  }

  getURLMap() {
    let sucact = this.getSucursalActiva();
    if (sucact) {
      this.urlmap = sucact.urlmap;
      return this.urlmap;
    }
    else {
      return '';
    }
  }

  getCiudades(sucursal?: number) {
    let params = new HttpParams();
    if (this.getTotal() > 0) {
      params = params.append('sucursal', this.getSucursalActiva().sucursal.toString());
      params = params.append('monto', this.getTotal().toString());
      params = params.append('unidades', this.getCantidadTotal().toString())
    } else {
      const idSucursal = sucursal ? sucursal.toString() : this.getSucursalActiva()?.sucursal.toString();

      if (idSucursal) {
        params = params.append('sucursal', idSucursal);
      } else {
        console.warn('getCiudades llamado sin sucursal y sin sucursal activa');
      }
    }
    return this.getGenericoSeguro(params, 'ecomciudades').pipe(tap(data => {
      this.ciudades.next(data['registros']);
    }));
  }

  getZonaEntrega(ciudadId: number) {
    let params = new HttpParams();
    params = params.append('ciudad', ciudadId.toString());
    return this.getGenericoSeguro(params, 'ecomzonaentrega');
  }

  /**
   * Setea los datos para determinar si hay que agregar flete y generar el articulo de flete en el carro
   * @param datosDelEnvio datos a guardar
   */
  setDatosEnvio(datosDelEnvio: DatosEnvio) {
    this.enviosService.setDatosEnvio(datosDelEnvio);
  }

  getDatosEnvio() {
    return this.datosEnvio;
  }

  agregarItemEnvio() {
    let carrito = this.getCarrito();
    if (this.datosEnvio) {
      let articuloEnvio: ArticuloPeticionEnviar[] = [];

      articuloEnvio.push(
        {
          marca: parseInt(this.marcaFlete),
          codigo: parseInt(this.codigoFlete),
          cantidad: 1,
          bultos: 1,
          precio: this.datosEnvio.costo,
          monto: this.datosEnvio.costo,
          reemplazo: 0,
        } as ArticuloPeticionEnviar
      );

      this.postGenericoSeguro('itempedidoweb', { articulos: articuloEnvio }).subscribe({
        next: data => {
          this.seAgregaronArtículosAlCarrito.next('nuevosItems')
          this.actualizarCarritoDeOtrasTabs();
          // console.log('agrega Item Envio', carrito)
        },
        error: error => {
          // console.log('Error agrega Item Envio', error)
          this.sincronizandoCarritoConBack = false;
        }
      })
    }
  }

  cleanUnpaidOrders() {
    let params = new HttpParams();
    return this.getGenericoSeguro(params, 'vaciarCarrito').pipe(tap(data => {
      // console.log(data);
    }));
  }

  getReemplazosProvider() {
    return this.remplasosProvider.asObservable();
  }

  getMontoMinimo() {
    return this.montoMinimo;
  }

  getPagoDiferido() {
    return this.pagoDiferido.asObservable();
  }

  getEnvioHabilitado() {
    return this.envioHabilitado.asObservable();
  }

  getRegistroHabilitado() {
    return this.registroHabilitado.asObservable();
  }

  getSucursalDefecto() {
    return this.sucursal_defecto;
  }

  returnBeneficios() {
    return this.beneficios.asObservable();
  }

  returnObligaLogin(): boolean {
    return this.obligaLogin;
  }

  returnUsaTurnos() {
    return this.usaTurnos.asObservable();
  }

  returnUsaBultos() {
    return this.usaBultos.asObservable();
  }

  returnUsaLista() {
    return this.usaLista.asObservable();
  }

  returnHorasMinimasTurno() {
    return this.horasMinimasTurno.asObservable();
  }

  isOcultarPrecio() {
    if (!this.authService.getUser()) {
      return !this.mostrarPreciosSinLogin;
    }

    if (this.authService.getUser().tipoUsuario === "2") {
      return true;
    }

    return this.authService.getUser().ocultarPrecios === '1';
  }

  isTipoUsuario() {

  }

  bajarImagen(articulo: ArticulosGeneral) {
    let params = new HttpParams();
    return this.httpClient.get(articulo.getFotoImagen(), {
      params, observe: 'response', responseType: 'blob'
    }).pipe(tap(data => {
      articulo.setMyBlob(data.body);
      articulo.setFoto(this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(articulo.getMyBlob())));
      // Si la descarga falla se completa igual: el artículo conserva la URL original
      // y el <img> la carga directo. Con errorHandler el observable nunca terminaba
      // y la imagen no se mostraba nunca.
    }), catchError(() => of(null)));
  }

  setImagenModal(img) {
    this.imagenModal = img;
  }

  getImagenPeticion() {
    let params = new HttpParams();
    let pathImg = this.imagenModal.split('/')[4];
    return this.httpClient.get(this.environmenturl.toString() + 'imagenes/' + pathImg, {
      headers: { "Authorization": this.authService.getUser().token }, params, observe: 'response', responseType: 'blob'


    }).pipe(tap(data => {
    }), catchError(this.errorHandler));
  }

  errorHandler(error: HttpErrorResponse) {
    return new Observable(err => {
      if (error.message) {
        // console.log(error.message);
      }
    });
  }

  descargImgaen(imagensrc: string,) {
    let params = new HttpParams();
    return this.httpClient.get(imagensrc, {
      params, observe: 'response', responseType: 'blob'
    }).pipe(map((data) => {
      return this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(data.body))
    }));
  }

  bajarArticulosPorSucursal(sucursal: string, lista: number = 0) {

    const sucursalFinal = String(sucursal);
    const listaFinal = Number(lista || 0);
  
    return forkJoin([
      this.obtenerArticulosCrudosPorLista(sucursalFinal, listaFinal),
      this.obtenerFotosArticulos()
    ]).pipe(
      map(([registros, fotos]) => this.aplicarFotosArticulos(registros, fotos)),
      tap(registros => {
        this.articulosSucursalDefecto = registros;
      }),
      map(registros => {
        return { registros };
      })
    );
  }

  /**
   * Arma el ítem sintético de "flete" (costo de envío) que se agrega al carrito/historial
   * como si fuera un artículo más, usando marcaFlete/codigoFlete como identificador.
   */
  private crearArticuloFlete(options: { monto: number, descripcion: string, presentacion: string, etiqueta?: string }): ArticulosEcommerce {
    const etiqueta = options.etiqueta ?? 'Flete';
    const marcaFleteNum = parseInt(this.marcaFlete);
    const fleteArt = new ArticulosEcommerce(
      marcaFleteNum,
      parseInt(this.codigoFlete),
      options.monto,
      0,
      options.monto,
      0,
      etiqueta,
      options.descripcion,
      1,
      options.presentacion,
      0,
      0,
      0,
      'FLETES',
      'FLETES',
      'FLETES',
      marcaFleteNum,
      1000,
      1000,
      options.monto,
      '',
      0,
      options.monto,
      etiqueta,
      undefined,
      2,
      [{ nombre: 'No Reemplazar', modo: '2', idcss: 'c9ft', activo: true }]
    );
    fleteArt.cantiadadpedido = 1;
    return fleteArt;
  }

  /**
   * Renglon virtual de descuento (no es un articulo real sincronizado, igual
   * que crearArticuloFlete) para que la promo global por Tipo Cliente OL se
   * vea como linea en la tabla del carrito, no solo como ajuste en getTotal().
   */
  private crearArticuloDescuentoGlobalTipoCliente(promocion: PorcentajePromo, monto: number): ArticulosEcommerce {
    const marcaPromoNum = promocion.getMarcaPromocion();
    const codigoPromoNum = promocion.getCodigoPromocion();
    const nombre = promocion.getNombrePromocion();
    const descuentoArt = new ArticulosEcommerce(
      marcaPromoNum,
      codigoPromoNum,
      monto * -1,
      0,
      monto * -1,
      0,
      'Descuento',
      nombre,
      1,
      '',
      0,
      0,
      0,
      'DESCUENTOS',
      'DESCUENTOS',
      'DESCUENTOS',
      marcaPromoNum,
      1000,
      1000,
      monto * -1,
      '',
      0,
      monto * -1,
      'Descuento',
      undefined,
      2,
      [{ nombre: 'No Reemplazar', modo: '2', idcss: 'c9ft', activo: true }]
    );
    descuentoArt.cantiadadpedido = 1;
    return descuentoArt;
  }

  getCarrito() {
    let carrito: ArticulosGeneral[] = [];
    this.sucursalesService.getSucursalActiva()?.articulos.forEach(articulo => {
      const tieneUnidades = articulo.getCantidad && articulo.getCantidad() > 0;
      const tieneBultos = articulo.getCantidadBultos && articulo.getCantidadBultos() > 0;
      if (tieneUnidades || tieneBultos) { carrito.push(articulo) }
    });
    const promocionesGlobales = this.getPromocionesDescuentoGlobal();
    if (promocionesGlobales.length) {
      const base = this.getBaseSinDescuentoParaPromoGlobal();
      promocionesGlobales.forEach(promocion => {
        const monto = this.calcularDescuentoPromoGlobal(promocion, base);
        if (monto !== 0) {
          const descuentoArt = this.crearArticuloDescuentoGlobalTipoCliente(promocion, monto);
          if (!this.containsObject(descuentoArt, carrito)) {
            carrito.push(descuentoArt);
          }
        }
      });
    }
    if (this.datosEnvio) {
      let fleteArt = this.crearArticuloFlete({
        monto: this.datosEnvio.costo,
        descripcion: 'ENVIO A ' + this.datosEnvio.nombreCiudad,
        presentacion: 'Codigo Postal: ' + this.datosEnvio.cp
      });
      if (!this.containsObject(fleteArt, carrito)) {
        carrito.push(fleteArt);
      }
    }
    else {
      const marcaFleteNum = Number(this.marcaFlete);
      const codigoFleteNum = Number(this.codigoFlete);
    
      if (!Number.isNaN(marcaFleteNum) && !Number.isNaN(codigoFleteNum)) {
        carrito = carrito.filter(articuloCarro => {
          const esFlete =
            Number(articuloCarro.getMarca()) === marcaFleteNum &&
            Number(articuloCarro.getCodigo()) === codigoFleteNum;
    
          return !esFlete;
        });
      }
    }
    //console.log("carrito",carrito)
    return carrito;
  }

  getTotal() {
    let total = 0;
    const usaBultosActual = (this.usaBultos.getValue() || 'N').toString().trim();
    const permiteBultosGlobal = usaBultosActual === 'S' || usaBultosActual === 'L';
    const combosProcesados = new Set<ComboPromo>();
    this.getCarrito().forEach(articuloCarro => {
      const usarBultosParaMonto = permiteBultosGlobal && articuloCarro.getCantidadBultos() > 0;
      const cantidadParaMonto = usarBultosParaMonto
        ? articuloCarro.getCantidadBultos() * articuloCarro.getUnidadesPorBulto()
        : articuloCarro.getCantidad();
      if (cantidadParaMonto > 0) {
        const esCombo = articuloCarro.misPromo && articuloCarro.misPromo[0] instanceof ComboPromo;
        // Con promos de Porcentaje por Categoria, una misma promo puede estar
        // pegada a muchos artículos distintos: misPromo[0].getPrecioCalculado()
        // calcula en base al primer artículo que resolvió la promo (articulo1),
        // no en base a ESTE articuloCarro. articuloCarro.getPrecioCalculado() sí
        // es por-artículo (usa modificacionPrecio, que preconPromo() ya acumula
        // correctamente por artículo vía aplicarPromo()).
        const esPorcentaje = articuloCarro.misPromo && articuloCarro.misPromo[0] instanceof PorcentajePromo;
        if (!usarBultosParaMonto && articuloCarro.misPromo && articuloCarro.misPromo.length != 0 && !esCombo) {
          if (!esPorcentaje && articuloCarro.getCantidad() % articuloCarro.misPromo[0].cantidadenPromo() === 0) {
            total += articuloCarro.misPromo[0].getPrecioCalculado();
          } else {
            total += articuloCarro.getPrecioCalculado();
          }
        } else {
          const precio = articuloCarro.isdeOferta()
            ? articuloCarro.getPrecioOferta()
            : articuloCarro.getPrecio();

          total += precio * cantidadParaMonto;

          if (esCombo) {
            const combo = articuloCarro.misPromo[0] as ComboPromo;
            if (!combosProcesados.has(combo)) {
              combosProcesados.add(combo);
              total -= combo.getDescontadoTotal();
            }
          }
        }
      }
    });
    return total;
  }

  /**
   * Devuelve la cantidad total de unidades en el carrito, si es fraccionado calcula cuantas fracciones del articulo hay (redondeo hacia arriba)
   * @returns cantidad total de items
   */
  getCantidadTotal(): number {
    let cantidadTotal: number = 0;
    this.getCarrito().forEach(
      articulo => {
        if (this.esLineaDescuentoGlobalTipoCliente(articulo)) {
          return;
        }
        let cantidadArticulo: number = 0;
        cantidadArticulo = articulo.getCantidad();
        if (articulo.getFraccion()) {
          cantidadArticulo = Math.ceil(articulo.getCantidad() / articulo.getFraccion())
          //console.log('getcantidadtotal',articulo.getCantidad(), articulo.getFraccion(), Math.floor(articulo.getCantidad() / articulo.getFraccion()), Math.ceil(articulo.getCantidad() / articulo.getFraccion()) )
        }
        cantidadTotal += cantidadArticulo;
      }
    );
    return cantidadTotal;
  }

  /**
   * Arma los argumentos de constructor comunes a las 5 clases de promoción
   * (Porcentaje/Monto/Diferencia/NxM/Combo). PromocionesWeb ya no tiene
   * cantidad1/cantidad2/regla1/regla2 propios: todo eso vive ahora en items[]
   * (ItemPromocionWeb), por eso quedan en 0/'' acá y se resuelven después vía
   * getCantidad1()/getCantidad2()/asignarPromociones().
   *
   * marca/codigo de la promo vienen del JSON (promocion['marca']/['codigo']):
   * cada promo tiene su propio articulo pseudo-promo real en VFP (marca fija
   * de Preferencias E-commerce + codigo=codPromocionWeb, autogenerado por
   * PromocionesWeb.evPosGrabar), usado como línea de descuento en
   * calcularMontoDePromociónDeArticulo() — ya no el primer artículo de
   * items[], ni un único artículo global compartido por todas las promos
   * (eso hacía que itempedidoweb pisara el descuento de una promo con el de
   * otra, porque ambas mandaban la misma marca+codigo).
   */
  private construirArgsPromo(promocion: any, imgenurl: string, imgenurl2: string, imgenurlMobile: string): ConstructorParameters<typeof PorcentajePromo> {
    const items = (promocion['items'] || []) as PromoItemEcommerce[];
    return [
      promocion['abv'].trim(),
      0,
      0,
      promocion['desde'],
      promocion['hasta'],
      promocion['codpromocionweb'],
      imgenurl,
      imgenurl2,
      promocion['monto'],
      promocion['nombre'],
      promocion['orden'],
      promocion['porcentaje'],
      '',
      '',
      promocion['sucursal'],
      promocion['lunes'],
      promocion['martes'],
      promocion['miercoles'],
      promocion['jueves'],
      promocion['viernes'],
      promocion['domingo'],
      promocion['sabado'],
      promocion['tipo'],
      this.generarid(5),
      promocion['marca'],
      promocion['codigo'],
      false,
      undefined,
      undefined,
      items,
      imgenurlMobile,
    ];
  }

  promocioneswebs(sucursal) {
    let params = new HttpParams();
    params = params.append('sucursal', sucursal)
    // clienteOL va como parametro comun (igual que sucursal), no via Authorization/
    // logintoken: la petición 710 tiene Seguridad=No (debe servir promos también a
    // visitantes anónimos) y con eso el gateway no decodifica el token igual.
    const usuario = this.authService.getUser();
    if (usuario && usuario.clienteol) {
      params = params.append('clienteOL', usuario.clienteol);
    }
    return this.getGenerico(params, 'promocioneswebec').pipe(tap({
      next: respuestapromocioneswebec => {
        //console.log('Esto es promocioneswebs', respuestapromocioneswebec)
        //console.log('promocioneswebs this.enviromenturl', this.environmenturl)

        this.promocionesEcommerce = [];
        this.promocionesGlobalTipoCliente = [];
        this.carruselPromocionesService.reiniciarSlides();

        respuestapromocioneswebec['registros'].forEach(promocion => {
          let imgenurl = this.cloudinaryService.resolveImageUrl(promocion['imagen'], {
            treatEmptyAsUnset: true
          });
          let imgenurl2 = this.cloudinaryService.resolveImageUrl(promocion['foto'], {
            treatEmptyAsUnset: true
          });
          let imgenurlMobile = this.cloudinaryService.resolveImageUrl(promocion['imagenmobile'], {
            treatEmptyAsUnset: true
          });
          const argsPromo = this.construirArgsPromo(promocion, imgenurl, imgenurl2, imgenurlMobile);

          if (promocion['porcentaje'] != 0 && promocion['tipo'] == "P" && promocion['condicion'] == "T") {
            this.promocionesGlobalTipoCliente.push(new PorcentajePromo(...argsPromo))
          }
          else if (promocion['porcentaje'] != 0 && promocion['tipo'] == "P") {
            this.promocionesEcommerce.push(new PorcentajePromo(...argsPromo))
          }

          if (promocion['monto'] > 0 && promocion['tipo'] == "P") {
            this.promocionesEcommerce.push(new MontoPromo(...argsPromo))
          }

          if (promocion['monto'] < 0 && promocion['tipo'] == "P") {
            this.promocionesEcommerce.push(new DiferenciaPromo(...argsPromo))
          }

          if (promocion['tipo'] == "C") {
            this.carruselPromocionesService.emitirSlide([new DiferenciaPromo(...argsPromo)]);
            this.getCarrouselSlides();
          }

          if (promocion['tipo'] == "N") {
            this.promocionesEcommerce.push(new NxMPromo(...argsPromo))
          }

          if (promocion['tipo'] == "M") {
            this.promocionesEcommerce.push(new ComboPromo(...argsPromo))
          }
        })
        //console.log("Aqui tengo todas las promociones ya formateadas",this.promocionesEcommerce)
      }
    }));
  }

  getCarrouselSlides() {
    this.carruselPromocionesService.getCarrouselSlides();
  }

  returnSlides() {
    return this.carruselPromocionesService.getSlidesProvider();
  }

  containsSlide(obj, list) {
    return this.carruselPromocionesService.containsSlide(obj, list);
  }

  eliminarPromos(articulo: ArticulosGeneral) {
    articulo.setCantidad(0);
    articulo.setCantidadBultos(0);
    articulo.setModificacionPrecio(0);
    articulo.getPromos().forEach((promo: PromocionesEccomerce) => {
      promo.resetArticulos();
    });
  }

  async sumarPromo(promocion: ArticulosGeneral, numero: number) {
    promocion.forzarAddPromo(numero);
  }

  sincronizarCarritoFrontyBack() {
    this.carritoObservables.unshift(this.enviarArticulosNuevosPetición())
  }

  /**
   * Obtiene el carrito del usuario, Si hay un carrito offline cargado levanta el modal correspondiente
   * para elegir si combinarlos o no
   * @returns el observable para ejecutar la consulta async
   */
  iniciarCarrito() {
    if (this.sincronizandoCarritoConBack) {
      return of(null);
    }
    let params = new HttpParams();
    this.sincronizandoCarritoConBack = true;
    //console.log('iniciarCarrito sincronizandoCarritoConBack ', this.sincronizandoCarritoConBack)
    return this.getGenericoSeguro(params, 'itempedidoweb').pipe(tap({

      next: itemscarrito => {
        this.sincronizandoCarritoConBack = false;
        if (!itemscarrito || !itemscarrito['registros']) {
          console.error('iniciarCarrito: Respuesta inválida del servidor', itemscarrito);
          this.terminoDeIniciarCarro.next('Error en carga');
          return;
        }
        const backupCarritoWeb: BackUptArticulo[] = itemscarrito['registros'];
        if (this.backUpCarritoOffline && this.backUpCarritoOffline.length && backupCarritoWeb && backupCarritoWeb.length &&
          this.carritosOfflineYWebSonIguales(this.backUpCarritoOffline, backupCarritoWeb)) {
          // El backup local es solo un reflejo del carrito que ya está sincronizado en el servidor
          // (p. ej. tras un reload): no hay nada real para combinar, y combinarlo duplicaría cantidades.
          this.backUpCarritoOffline = [];
        }
        const ambosCarritosNoVacios = (this.backUpCarritoOffline && this.backUpCarritoOffline.length) && (backupCarritoWeb && backupCarritoWeb.length);
        if (ambosCarritosNoVacios) {
          setTimeout(() => {
            this.modal.open('hay-carrito-offline');
          }, 500);

          let obs = this.getHayCarritoOfflineRespuestaObservable().subscribe({
            next: respuestaUsuario => {
              this.sincronizandoCarritoConBack = false;
              this.modal.close('hay-carrito-offline')
              if (respuestaUsuario === 'DESCARTAR CARRITO WEB') {
                const descartarCarritoWeb = true;
                this.cargarBackupsEnCarrito(descartarCarritoWeb, backupCarritoWeb, this.backUpCarritoOffline);
                this.terminoDeIniciarCarro.next('Cargado Carro')
              }
              if (respuestaUsuario === 'COMBINAR CARRITOS') {
                const combinarCarritoWeb = false;
                this.cargarBackupsEnCarrito(combinarCarritoWeb, backupCarritoWeb, this.backUpCarritoOffline);
                this.terminoDeIniciarCarro.next('Cargado Carro')
              }
              obs.unsubscribe();
            },
            error: error => {
              this.sincronizandoCarritoConBack = false;
            }
          })
          return
        }
        this.cargarBackupsEnCarrito(false, backupCarritoWeb, this.backUpCarritoOffline);
        //this.terminoDeIniciarCarro.next('Cargado Carro')
        //this.articulosSucursalCargados.next('listo');
      },
      error: error => {
        this.sincronizandoCarritoConBack = false;
        console.error('ERROR iniciarCarrito itempedidoweb:', error);
        // Si no se pudo consultar el carrito guardado en el back, igual reaplicamos
        // el carrito offline (backUpCarritoOffline) para no perder lo que el usuario
        // ya había cargado antes de loguearse.
        if (this.backUpCarritoOffline && this.backUpCarritoOffline.length) {
          this.cargarBackupsEnCarrito(false, [], this.backUpCarritoOffline);
        } else {
          this.terminoDeIniciarCarro.next('Error en sincronización');
        }
      }

    }))
  }
  /**
   * Observable para notificar respuesta del usuario en modal hay-carrito-offline
   * @returns observable para suscribirse
   */
  getHayCarritoOfflineRespuestaObservable(): Observable<string> {
    return this.hayCarritoOfflineRespuestaSubject.asObservable();
  }

  /**
   * Notifica a traves del observable la respuesta del usuario en modal hay-carrito-offline
   * @param respuestaUsuario string con la opción elegida
   */
  enviarCarritoOfflineRespuesta(respuestaUsuario: 'DESCARTAR CARRITO WEB' | 'COMBINAR CARRITOS') {
    this.hayCarritoOfflineRespuestaSubject.next(respuestaUsuario)
  }

  /**
   * Recorre todos los articulos y setea las cantidades segun los backups utilizados
   * @param descartarCarritoweb setea si se debe descartar el carrito previo del usuario
   * @param backupCarritoWeb  articulos del carrito del usuario
   * @param backupCarritoOffline articulos del carrito cargado sin login
   */
  cargarBackupsEnCarrito(descartarCarritoweb: boolean, backupCarritoWeb: BackUptArticulo[], backupCarritoOffline: BackUptArticulo[]) {
    if (!this.sucursalesService.getSucursalActiva() || !this.sucursalesService.getSucursalActiva().articulos) {
      console.warn('cargarBackupsEnCarrito: sucursalactiva o articulos no definidos');
      this.terminoDeIniciarCarro.next('Cargado Carro');
      return;
    }

    this.sucursalesService.getSucursalActiva().articulos.forEach(

      (articulo: ArticulosEcommerce) => {
        let articuloBackupWebEncontrado: boolean = false;
        let articuloBackupOfflineEncontrado: boolean = false;
        backupCarritoWeb.forEach(
          (articuloBackupWeb: BackUptArticulo) => {
            //if ((articuloBackupWeb.marca === articulo.getMarca()) && (articuloBackupWeb.codigo === articulo.getCodigo())) {
            if (this.mismoArticulo(articuloBackupWeb, articulo)) {
              //articulo.setCantidadInicial(articuloBackupWeb.cantidad);
              //articulo.setCantidad(articuloBackupWeb.cantidad);
              //articulo.setCantidadBultosInicial(articuloBackupWeb.bultos || 0);
              //articulo.setCantidadBultos(articuloBackupWeb.bultos || 0);
              articulo.setCantidadInicial(Number(articuloBackupWeb.cantidad || 0));
              articulo.setCantidad(Number(articuloBackupWeb.cantidad || 0));
              const bultosWeb = Number(
                articuloBackupWeb.bultos ??
                (articuloBackupWeb as any).cantidadbultos ??
                (articuloBackupWeb as any).cantidadBultos ??
                0
              );
              
              articulo.setCantidadBultosInicial(bultosWeb);
              articulo.setCantidadBultos(bultosWeb);
              articulo.setObservacion(articuloBackupWeb.observacion || '');
              articulo.setObservacionInicial(articuloBackupWeb.observacion || '');
              if (descartarCarritoweb) {
                articulo.setCantidad(0);
                articulo.setCantidadBultos(0);
                articulo.setObservacion('');
                articulo.setObservacionInicial('');
              }
            this.tienePromoArticulo(articulo).forEach(
              (promo: PromocionesEccomerce) => { articulo.setPromo(promo)}
            );
            articulo.operacionesExtras();
            articuloBackupWebEncontrado = true;
            }
          }
        )
        if (articuloBackupWebEncontrado) {
          backupCarritoWeb = backupCarritoWeb.filter(
            (articuloBackupWeb: BackUptArticulo) => {
              //const articuloAfiltrar = (articuloBackupWeb.marca === articulo.getMarca()) && (articuloBackupWeb.codigo === articulo.getCodigo());
              const articuloAfiltrar = this.mismoArticulo(articuloBackupWeb, articulo);
              return !articuloAfiltrar;
            }
          )
        }

        backupCarritoOffline.forEach(
          (articuloBackupOffline: BackUptArticulo) => {
            //if ((articuloBackupOffline.marca === articulo.getMarca()) && (articuloBackupOffline.codigo === articulo.getCodigo())) {
              if (this.mismoArticulo(articuloBackupOffline, articulo)) {
              articulo.agregarCantidad(Number(articuloBackupOffline.cantidad || 0));
              const bultosOffline = Number(
                articuloBackupOffline.bultos ??
                (articuloBackupOffline as any).cantidadbultos ??
                (articuloBackupOffline as any).cantidadBultos ??
                0
              );
              
              articulo.agregarBultos(bultosOffline);
              articulo.operacionesExtras();
              //console.log('agregado de carrito offline', articulo,backupCarritoOffline)
              articuloBackupOfflineEncontrado = true;
            }
          }
        )

        if (articuloBackupOfflineEncontrado) {
          backupCarritoOffline = this.backUpCarritoOffline.filter(
            (articuloBackupOffline: BackUptArticulo) => {
              //const articuloAfiltrar = (articuloBackupOffline.marca === articulo.getMarca()) && (articuloBackupOffline.codigo === articulo.getCodigo())
              const articuloAfiltrar = this.mismoArticulo(articuloBackupOffline, articulo);
              return !articuloAfiltrar
            }
          )
          this.backUpCarritoOffline = backupCarritoOffline;
        }
      }
    );

    // Fuerza refresco visual después de aplicar carrito web
    this.aplicarVistaListaActual();

    this.sucursalesService.emitSucursalActivaActual();
    this.seAgregaronArtículosAlCarrito.next('nuevosItems');
    
    // Este aviso sí va acá, porque acá ya está aplicado el carrito
    this.articulosSucursalCargados.next('listo');
    
    this.terminoDeIniciarCarro.next('Cargado Carro');
  }

  getTerminoDeIniciarCarro() {
    return this.terminoDeIniciarCarro.asObservable()
  }

  /**
   * @deprecated siendo reemplazada por enviarArticulosNuevosPetición()
   */
  ajustarCuentas(): Observable<void> {
    return new Observable<void>(sub => {
      //console.log('ajustar cuentas')
      let user = this.authService.getUser();
      //console.log('ajustar cuentas user',user)

      if (!user) {
        user = JSON.parse(localStorage.getItem('currentUser'));
      }
      //console.log('ajustar cuentas',user)
      if (user) {
        let articulosAlcambio = [];
        // let articulosAlcambio2 = [];
        //se revisan todos los articulos por si se elije la opcion de recompra y varios articulos son actualizados al mismo tiempo
        this.sucursalesService.getSucursalActiva().articulos.forEach(
          articulo => {
            //console.log('ajustarcuentas articulos ', articulo)
            if ((articulo as ArticulosGeneral).getCantidadInicial() != (articulo as ArticulosGeneral).getCantidad()) {
              if ((articulo as ArticulosGeneral).getCantidad() > (articulo as ArticulosGeneral).getCantidadInicial()) {
                if (articulo.isdeoferta && !articulo.isdePromo) {
                  articulosAlcambio.push({
                    marca: (articulo as ArticulosGeneral).getMarca(),
                    codigo: (articulo as ArticulosGeneral).getCodigo(),
                    cantidad: (articulo as ArticulosGeneral).getCantidad(),
                    precio: (articulo as ArticulosGeneral).getPrecioOferta(),
                    monto: (articulo as ArticulosGeneral).getCantidad() * (articulo as ArticulosGeneral).getPrecioOferta(),
                    reemplazo: articulo.getRemplazo(),
                    observacion: (articulo as ArticulosEcommerce).getObservacion?.() || '',
                  });
                }
                /*             if (articulo.isdeoferta && articulo.isdePromo) {
                                articulosAlcambio.push({
                                  marca: (articulo as ArticulosGeneral).getMarca(),
                                  codigo: (articulo as ArticulosGeneral).getCodigo(),
                                  cantidad: (articulo as ArticulosGeneral).getCantidad(),
                                  precio: (articulo as ArticulosGeneral).getPrecioCalculado() / (articulo as ArticulosGeneral).getCantidad(),
                                  monto: (articulo as ArticulosGeneral).getPrecioCalculado(),
                                  reemplazo: articulo.getRemplazo(),
                                }); */
                if (articulo.isdeoferta && articulo.isdePromo) {
                  articulosAlcambio.push({
                    marca: (articulo as ArticulosGeneral).getMarca(),
                    codigo: (articulo as ArticulosGeneral).getCodigo(),
                    cantidad: (articulo as ArticulosGeneral).getCantidad(),
                    precio: (articulo as ArticulosGeneral).getPrecioOferta(),
                    monto: (articulo as ArticulosGeneral).getCantidad() * (articulo as ArticulosGeneral).getPrecioOferta(),
                    reemplazo: articulo.getRemplazo(),
                    observacion: (articulo as ArticulosEcommerce).getObservacion?.() || '',
                  });

                }
                if (!articulo.isdeoferta && articulo.isdePromo) {
                  articulosAlcambio.push({
                    marca: (articulo as ArticulosGeneral).getMarca(),
                    codigo: (articulo as ArticulosGeneral).getCodigo(),
                    cantidad: (articulo as ArticulosGeneral).getCantidad(),
                    precio: (articulo as ArticulosGeneral).getPrecioCalculado() / (articulo as ArticulosGeneral).getCantidad(),
                    monto: (articulo as ArticulosGeneral).getPrecioCalculado(),
                    reemplazo: articulo.getRemplazo(),
                    observacion: (articulo as ArticulosEcommerce).getObservacion?.() || '',
                  });
                }
                if (!articulo.isdeoferta && !articulo.isdePromo) {
                  articulosAlcambio.push({
                    marca: (articulo as ArticulosGeneral).getMarca(),
                    codigo: (articulo as ArticulosGeneral).getCodigo(),
                    cantidad: (articulo as ArticulosGeneral).getCantidad(),
                    precio: (articulo as ArticulosGeneral).getPrecio(),
                    monto: (articulo as ArticulosGeneral).getCantidad() * (articulo as ArticulosGeneral).getPrecio(),
                    reemplazo: articulo.getRemplazo(),
                    observacion: (articulo as ArticulosEcommerce).getObservacion?.() || '',
                  });
                }
                // articulosAlcambio2.push({
                //   marca: (articulo as ArticulosGeneral).getMarca(),
                //   codigo: (articulo as ArticulosGeneral).getCodigo(),
                //   cantidad: (articulo as ArticulosGeneral).getCantidad(),
                //   precio: (articulo as ArticulosGeneral).getPrecio(),
                //   monto: (articulo as ArticulosGeneral).getCantidad() * (articulo as ArticulosGeneral).getPrecio(),
                //   reemplazo: articulo.getRemplazo(),
                // });
                (articulo as ArticulosGeneral).setCantidadInicial((articulo as ArticulosGeneral).getCantidad());
              }
              else {
                if (articulo.isdeoferta && !articulo.isdePromo) {
                  articulosAlcambio.push({
                    marca: (articulo as ArticulosGeneral).getMarca(),
                    codigo: (articulo as ArticulosGeneral).getCodigo(),
                    cantidad: (articulo as ArticulosGeneral).getCantidad(),
                    precio: (articulo as ArticulosGeneral).getPrecioOferta(),
                    monto: (articulo as ArticulosGeneral).getCantidad() * (articulo as ArticulosGeneral).getPrecioOferta(),
                    reemplazo: articulo.getRemplazo(),
                    observacion: (articulo as ArticulosEcommerce).getObservacion?.() || '',
                  });
                }
                if (articulo.isdeoferta && articulo.isdePromo) {
                  articulosAlcambio.push({
                    marca: (articulo as ArticulosGeneral).getMarca(),
                    codigo: (articulo as ArticulosGeneral).getCodigo(),
                    cantidad: (articulo as ArticulosGeneral).getCantidad(),
                    precio: (articulo as ArticulosGeneral).getPrecioCalculado() / (articulo as ArticulosGeneral).getCantidad(),
                    monto: (articulo as ArticulosGeneral).getPrecioCalculado(),
                    reemplazo: articulo.getRemplazo(),
                    observacion: (articulo as ArticulosEcommerce).getObservacion?.() || '',
                  });
                }
                if (!articulo.isdeoferta && articulo.isdePromo) {
                  articulosAlcambio.push({
                    marca: (articulo as ArticulosGeneral).getMarca(),
                    codigo: (articulo as ArticulosGeneral).getCodigo(),
                    cantidad: (articulo as ArticulosGeneral).getCantidad(),
                    precio: (articulo as ArticulosGeneral).getPrecioCalculado() / (articulo as ArticulosGeneral).getCantidad(),
                    monto: (articulo as ArticulosGeneral).getPrecioCalculado(),
                    reemplazo: articulo.getRemplazo(),
                    observacion: (articulo as ArticulosEcommerce).getObservacion?.() || '',
                  });
                }
                if (!articulo.isdeoferta && !articulo.isdePromo) {
                  articulosAlcambio.push({
                    marca: (articulo as ArticulosGeneral).getMarca(),
                    codigo: (articulo as ArticulosGeneral).getCodigo(),
                    cantidad: (articulo as ArticulosGeneral).getCantidad(),
                    precio: (articulo as ArticulosGeneral).getPrecio(),
                    monto: (articulo as ArticulosGeneral).getCantidad() * (articulo as ArticulosGeneral).getPrecio(),
                    reemplazo: articulo.getRemplazo(),
                    observacion: (articulo as ArticulosEcommerce).getObservacion?.() || '',
                  });
                }

                // articulosAlcambio2.push({
                //   marca: (articulo as ArticulosGeneral).getMarca(),
                //   codigo: (articulo as ArticulosGeneral).getCodigo(),
                //   cantidad: (articulo as ArticulosGeneral).getCantidad(),
                //   precio: (articulo as ArticulosGeneral).getPrecio(),
                //   monto: (articulo as ArticulosGeneral).getCantidad() * (articulo as ArticulosGeneral).getPrecio(),
                //   reemplazo: articulo.getRemplazo(),
                // });
                (articulo as ArticulosGeneral).setCantidadInicial((articulo as ArticulosGeneral).getCantidad());
              }
            }
          });
        if (articulosAlcambio.length == 0) {
          sub.next();
          sub.complete();
          return;
        }

        if (localStorage.getItem('instancia') == undefined) {
          localStorage.setItem('instancia', '0');
        }
      }
      sub.next();
      sub.complete();
    });
  }

  /**
   * Revisa si hay una diferencia entre la cantidad inicial y actual de todos los articulos, si lo hay manda la actualizacion en peticion.
   * Calcula las promociones y ofertas y genera los objetos promocion en peticion.
   * @returns un observable para llamar la funcion asíncronamente
   */
  enviarArticulosNuevosPetición(): Observable<void> {
    return new Observable<void>(sub => {
      let user = this.authService.getUser();
      console.log('enviarArticulosNuevosPetición user',user)
      if (user === undefined) {
        user = JSON.parse(localStorage.getItem('currentUser'));
      }
      this.seAgregaronArtículosAlCarrito.next('nuevosItems')
      //console.log('enviarArticulosNuevosPetición user',user)
      if (user) {
        let articulosAlcambio: ArticuloPeticionEnviar[] = [];
        let objetosPromocion: ArticuloPeticionEnviar[] = [];
        let articulosSincronizados: ArticulosEcommerce[] = [];
        //se revisan todos los articulos por si se elije la opcion de recompra y varios articulos son actualizados al mismo tiempo
        this.sucursalesService.getSucursalActiva().articulos.forEach(
          (articulo: ArticulosEcommerce) => {
            const huboCambioEnCantidadDelArtículo: boolean = articulo.getCantidadInicial() !== articulo.getCantidad() ||
              articulo.getCantidadBultosInicial() !== articulo.getCantidadBultos() || articulo.getObservacionInicial() !== articulo.getObservacion();

            if (huboCambioEnCantidadDelArtículo) {
              this.sincronizandoCarritoConBack = true;
              //console.log('huboCambioEnCantidadDelArtículo', huboCambioEnCantidadDelArtículo, articulo)
              const cantidadParaMonto = articulo.getCantidadBultos() > 0 ? articulo.getCantidadBultos() * articulo.getUnidadesPorBulto() : articulo.getCantidad();
              if (articulo.isdeoferta) {
                articulosAlcambio.push(
                  {
                    marca: articulo.getMarca(),
                    codigo: articulo.getCodigo(),
                    cantidad: articulo.getCantidad(),
                    bultos: articulo.getCantidadBultos(),
                    precio: articulo.getPrecioOferta(),
                    monto: articulo.getPrecioOferta() * cantidadParaMonto,
                    reemplazo: articulo.getRemplazo(),
                    observacion: articulo.getObservacion(),
                  } as ArticuloPeticionEnviar
                );
                if (articulo.isdePromo) {
                  objetosPromocion = objetosPromocion.concat(this.calcularMontoDePromociónDeArticulo(articulo, articulo.getPrecioOferta()))
                }
              }
              else {
                articulosAlcambio.push(
                  {
                    marca: articulo.getMarca(),
                    codigo: articulo.getCodigo(),
                    cantidad: articulo.getCantidad(),
                    bultos: articulo.getCantidadBultos(),
                    precio: articulo.getPrecio(),
                    monto: articulo.getPrecio() * cantidadParaMonto,
                    reemplazo: articulo.getRemplazo(),
                    observacion: articulo.getObservacion(),
                  } as ArticuloPeticionEnviar
                );
                if (articulo.isdePromo) {
                  objetosPromocion = objetosPromocion.concat(this.calcularMontoDePromociónDeArticulo(articulo, articulo.getPrecio()))
                }
              }
              articulosSincronizados.push(articulo);
              //articulo.setCantidadInicial(articulo.getCantidad());
              //articulo.setCantidadBultosInicial(articulo.getCantidadBultos());
              //articulo.setObservacionInicial(articulo.getObservacion());
            }
          }
        );

        // Combo: el descuento se calcula una sola vez por promo (no por
        // artículo), porque involucra varios artículos a la vez.
        const combosProcesados = new Set<ComboPromo>();
        articulosSincronizados.forEach((articulo: ArticulosEcommerce) => {
          (articulo.misPromo || []).forEach(promocion => {
            if (!(promocion instanceof ComboPromo) || combosProcesados.has(promocion)) {
              return;
            }
            combosProcesados.add(promocion);
            const descuentoTotal = promocion.getDescontadoTotal();
            if (descuentoTotal !== 0) {
              objetosPromocion.push(
                {
                  marca: promocion.getMarcaPromocion(),
                  codigo: promocion.getCodigoPromocion(),
                  cantidad: 1,
                  precio: descuentoTotal * -1,
                  monto: descuentoTotal * -1,
                  reemplazo: 1,
                  observacion: promocion.getNombrePromocion(),
                } as ArticuloPeticionEnviar
              );
            }
          });
        });

        objetosPromocion = objetosPromocion.concat(this.calcularMontoDePromocionGlobalCliente());

        if (articulosAlcambio.length == 0) {
          this.sincronizandoCarritoConBack = false;
          sub.next();
          sub.complete();
          return;
        }

        if (objetosPromocion.length) {
          articulosAlcambio = articulosAlcambio.concat(objetosPromocion)
        }
        if (localStorage.getItem('instancia') == undefined) {
          localStorage.setItem('instancia', '0');
        }
        
        this.postGenericoSeguro('itempedidoweb', { articulos: articulosAlcambio }).subscribe({
          next: data => {
            articulosSincronizados.forEach((articulo: ArticulosEcommerce) => {
              articulo.setCantidadInicial(articulo.getCantidad());
              articulo.setCantidadBultosInicial(articulo.getCantidadBultos());
              articulo.setObservacionInicial(articulo.getObservacion());
            });
        
            this.sincronizandoCarritoConBack = false;
            sub.next();
            sub.complete();
            this.seAgregaronArtículosAlCarrito.next('nuevosItems');
            this.actualizarCarritoDeOtrasTabs();
          },
          error: error => {
            this.sincronizandoCarritoConBack = false;
            console.error('ERROR guardando itempedidoweb:', error);
            sub.error(error);
          }
        });
        return;
      }
      sub.next();
      sub.complete();
    });
  }

  /**
   * Calcula el objeto promoción que realiza el descuento del artículo
   * @param articulo artículo al que se aplica la promoción
   * @param precioArticulo precio a usar del artículo en los calculos (puede ser o no precio de oferta)
   * @returns objeto promoción que compensa el valor original de los artículos
   */
  calcularMontoDePromociónDeArticulo(articulo: ArticulosEcommerce, precioArticulo: number): ArticuloPeticionEnviar[] {
    console.log('calcularMontoDePromociónDeArticulo mispromos', articulo.misPromo)
    let objetosPromocion: ArticuloPeticionEnviar[] = [];
    let cantidadDeArticulo = articulo.getCantidad();
    const promocionesDelArticulo = articulo.misPromo.slice().sort(
      (promoA, promoB) => {
        return promoA.getOrden() - promoB.getOrden()
      }
    )
    promocionesDelArticulo.forEach(
      promocion => {
        if (promocion instanceof ComboPromo) {
          // Combo involucra varios artículos a la vez; se calcula aparte,
          // una sola vez por combo, en enviarArticulosNuevosPetición().
          return
        }
        while (cantidadDeArticulo >= promocion.getCantidad1()) {
          console.log('calcularMontoDePromociónDeArticulo promocion', promocion)
          if (promocion instanceof PorcentajePromo) {
            console.log('porcentaje', promocion.montoTotalADescontar, precioArticulo, promocion.getCantidad1(), promocion.getPorcentaje() / 100)
            promocion.montoTotalADescontar += precioArticulo * promocion.getCantidad1() * (promocion.getPorcentaje() / 100);
          }

          if (promocion instanceof MontoPromo) {
            console.log('monto positivo')
            promocion.montoTotalADescontar += precioArticulo * promocion.getCantidad1() - promocion.getDescontado();
          }

          if (promocion instanceof DiferenciaPromo) {
            console.log('monto negativo')
            promocion.montoTotalADescontar += promocion.getDescontado();
          }

          if (promocion instanceof NxMPromo) {
            promocion.montoTotalADescontar += precioArticulo * (promocion.getCantidad1() - promocion.getCantidad2());
          }
          cantidadDeArticulo = cantidadDeArticulo - promocion.getCantidad1();
          console.log('cantidaddearticulo', cantidadDeArticulo)
        }
        if (promocion.montoTotalADescontar !== 0) {
          objetosPromocion.push(
            {
              marca: promocion.getMarcaPromocion(),
              codigo: promocion.getCodigoPromocion(),
              cantidad: 1,
              precio: promocion.montoTotalADescontar * -1,
              monto: promocion.montoTotalADescontar * -1,
              reemplazo: 1,
              observacion: promocion.getNombrePromocion(),
            } as ArticuloPeticionEnviar
          )
          promocion.montoTotalADescontar = 0;
        }
      }
    )

    console.log('calcularMontoDePromociónDeArticulo promociones generadas', objetosPromocion)
    return objetosPromocion;
  }

  /**
   * Suma precio de lista * cantidad de los articulos del carrito que todavia
   * NO tienen ningun descuento propio (ni de otra promo ni de oferta). Es la
   * base sobre la que pegan las promos globales por Tipo Cliente OL, tanto
   * para el total que se muestra en pantalla (getTotal()) como para la linea
   * de descuento que se sincroniza al backend (calcularMontoDePromocionGlobalCliente()).
   */
  private getBaseSinDescuentoParaPromoGlobal(): number {
    let base = 0;
    (this.sucursalesService.getSucursalActiva()?.articulos || []).forEach((articulo: ArticulosGeneral) => {
      const cantidadParaMonto = articulo.getCantidadBultos() > 0 ? articulo.getCantidadBultos() * articulo.getUnidadesPorBulto() : articulo.getCantidad();
      if (cantidadParaMonto > 0 && !articulo.isdePromo && !articulo.isdeoferta) {
        base += articulo.getPrecio() * cantidadParaMonto;
      }
    });
    return base;
  }

  /**
   * Suma del descuento de todas las promos globales por Tipo Cliente OL
   * activas. Usado por getTotal() para reflejar el descuento en el total que
   * se muestra en pantalla (esa cuenta es 100% local, no espera sync con el back).
   */
  getMontoDescuentoGlobalTipoCliente(): number {
    const promocionesGlobales = this.getPromocionesDescuentoGlobal();
    if (!promocionesGlobales.length) {
      return 0;
    }
    const base = this.getBaseSinDescuentoParaPromoGlobal();
    return promocionesGlobales.reduce(
      (acumulado, promocion) => acumulado + this.calcularDescuentoPromoGlobal(promocion, base),
      0
    );
  }

  /**
   * Descuento de UNA promo global puntual (no la suma de todas), para
   * mostrarla como fila propia en la tabla del carrito.
   */
  getMontoDescuentoPromoGlobal(promocion: PorcentajePromo): number {
    return this.calcularDescuentoPromoGlobal(promocion, this.getBaseSinDescuentoParaPromoGlobal());
  }

  /**
   * Promos que descuentan sobre el total del carrito (una linea propia cada
   * una): las de Tipo Cliente OL y las de Codigo Promocional ingresadas.
   */
  getPromocionesDescuentoGlobal(): PorcentajePromo[] {
    return [...(this.promocionesGlobalTipoCliente || []), ...(this.promocionesCodigoPromocional || [])];
  }

  /**
   * Porcentaje sobre la base; si la promo no tiene porcentaje (solo Codigo
   * Promocional puede venir asi) descuenta el monto fijo, sin pasarse de la base.
   */
  private calcularDescuentoPromoGlobal(promocion: PorcentajePromo, base: number): number {
    if (promocion.getPorcentaje() !== 0) {
      return base * (promocion.getPorcentaje() / 100);
    }
    return Math.min(Math.abs(promocion.getMontoPromocion()), base);
  }

  /**
   * True si el articulo es el renglon virtual (marca/codigo del pseudo-
   * articulo de la promo) que crearArticuloDescuentoGlobalTipoCliente() agrega
   * a getCarrito(). Sirve para excluirlo de listados que lo muestran con
   * controles de cantidad (no tiene sentido "sumarle unidades" a un descuento)
   * y en su lugar renderizarlo con markup propio, como ya se hace con Combo.
   */
  esLineaDescuentoGlobalTipoCliente(articulo: ArticulosGeneral): boolean {
    return this.getPromocionesDescuentoGlobal().some(
      promocion => promocion.getMarcaPromocion() === articulo.getMarca() && promocion.getCodigoPromocion() === articulo.getCodigo()
    );
  }

  /**
   * Calcula el descuento de las promos globales por Tipo Cliente OL: % sobre
   * la suma de los articulos del carrito que todavia NO tienen ningun
   * descuento propio (ni de otra promo ni de oferta), para no acumularse
   * arriba de un combo/promo/oferta ya aplicado. Genera una unica linea de
   * descuento por promo, igual que hace el Combo.
   */
  calcularMontoDePromocionGlobalCliente(): ArticuloPeticionEnviar[] {
    const objetosPromocion: ArticuloPeticionEnviar[] = [];
    const promocionesGlobales = this.getPromocionesDescuentoGlobal();
    if (!promocionesGlobales.length) {
      return objetosPromocion;
    }
    const base = this.getBaseSinDescuentoParaPromoGlobal();
    promocionesGlobales.forEach(promocion => {
      const montoADescontar = this.calcularDescuentoPromoGlobal(promocion, base);
      // Con descuento 0 (carrito vacio o todo con otro descuento) se manda
      // cantidad 0: itempedidoweb borra la linea, si no quedaba la anterior.
      objetosPromocion.push(
        {
          marca: promocion.getMarcaPromocion(),
          codigo: promocion.getCodigoPromocion(),
          cantidad: montoADescontar !== 0 ? 1 : 0,
          precio: montoADescontar * -1,
          monto: montoADescontar * -1,
          reemplazo: 1,
          observacion: promocion.getNombrePromocion(),
        } as ArticuloPeticionEnviar
      );
    });
    return objetosPromocion;
  }

  getPromocionesGlobalTipoCliente(): PorcentajePromo[] {
    return this.promocionesGlobalTipoCliente;
  }

  getPromocionesCodigoPromocional(): PorcentajePromo[] {
    return this.promocionesCodigoPromocional;
  }

  /**
   * Valida el codigo contra el back (promocioneswebec con codigopromocional)
   * y si existe una promo tipo K vigente la suma al carrito. Devuelve el
   * mensaje de error, o '' si se aplico.
   */
  aplicarCodigoPromocional(codigo: string): Observable<string> {
    const codigoNormalizado = (codigo || '').trim().toUpperCase();
    if (!codigoNormalizado) {
      return of('Ingrese un código promocional.');
    }
    if (this.promocionesCodigoPromocional.some(promocion => promocion.getCodigoPromocionalIngresado() === codigoNormalizado)) {
      return of('El código ya está aplicado.');
    }
    return this.buscarPromocionCodigo(codigoNormalizado).pipe(map(promocion => {
      if (!promocion) {
        return 'El código promocional no es válido o no está vigente.';
      }
      this.promocionesCodigoPromocional.push(promocion);
      this.guardarCodigosPromocionales();
      this.enviarLineasDescuentoGlobal();
      this.seAgregaronArtículosAlCarrito.next('codigo promocional');
      return '';
    }));
  }

  quitarCodigoPromocional(promocion: PorcentajePromo) {
    this.promocionesCodigoPromocional = this.promocionesCodigoPromocional.filter(k => k !== promocion);
    this.guardarCodigosPromocionales();
    if (this.authService.getUser()) {
      this.postGenericoSeguro('itempedidoweb', {
        articulos: [{
          marca: promocion.getMarcaPromocion(),
          codigo: promocion.getCodigoPromocion(),
          cantidad: 0,
          precio: 0,
          monto: 0,
          reemplazo: 1,
          observacion: '',
        } as ArticuloPeticionEnviar]
      }).subscribe();
    }
    this.seAgregaronArtículosAlCarrito.next('codigo promocional');
  }

  /**
   * Al recargar la pagina vuelve a validar los codigos que el cliente ya
   * habia ingresado (pueden haber vencido o deshabilitarse en el medio).
   */
  private async restaurarCodigosPromocionales() {
    let codigos: string[] = [];
    try {
      codigos = JSON.parse(localStorage.getItem('codigosPromocionales') || '[]');
    } catch (error) {
      codigos = [];
    }
    this.promocionesCodigoPromocional = [];
    for (const codigo of codigos) {
      const promocion = await this.buscarPromocionCodigo(codigo).toPromise().catch(() => null);
      if (promocion) {
        this.promocionesCodigoPromocional.push(promocion);
      }
    }
    this.guardarCodigosPromocionales();
  }

  private limpiarCodigosPromocionales() {
    this.promocionesCodigoPromocional = [];
    localStorage.removeItem('codigosPromocionales');
  }

  private buscarPromocionCodigo(codigo: string): Observable<PorcentajePromo | null> {
    let params = new HttpParams();
    const sucursal = (this.sucursalesService.getSucursalActiva()?.sucursal || this.sucursal_defecto)?.toString();
    if (sucursal) {
      params = params.append('sucursal', sucursal);
    }
    params = params.append('codigopromocional', codigo);
    return this.getGenerico(params, 'promocioneswebec').pipe(map(respuesta => {
      const promocion = (respuesta?.['registros'] || []).find(k => k['tipo'] == 'K');
      if (!promocion) {
        return null;
      }
      const nueva = new PorcentajePromo(...this.construirArgsPromo(promocion, '', '', ''));
      nueva.setCodigoPromocionalIngresado(codigo);
      return nueva;
    }));
  }

  private guardarCodigosPromocionales() {
    localStorage.setItem(
      'codigosPromocionales',
      JSON.stringify(this.promocionesCodigoPromocional.map(promocion => promocion.getCodigoPromocionalIngresado()))
    );
  }

  /**
   * Manda ya las lineas de descuento global: enviarArticulosNuevosPetición()
   * solo las agrega cuando cambio algun articulo, y aplicar un codigo no
   * cambia ninguno.
   */
  private enviarLineasDescuentoGlobal() {
    if (!this.authService.getUser()) {
      return;
    }
    const lineas = this.calcularMontoDePromocionGlobalCliente();
    if (lineas.length) {
      this.postGenericoSeguro('itempedidoweb', { articulos: lineas }).subscribe();
    }
  }

  getPedidoWeb() {
    let params = new HttpParams();
    return this.getGenericoSeguro(params, 'itempedidoweb').pipe(tap((data) => { }));
  }

  /**
   * Se asignan los objetos promocion a los artículos correspondientes.
   *
   * PromocionesWeb ya no tiene regla1/regla2/marca/codigo propios: todas las
   * promos (P/C/O/N/M) traen sus artículos como renglones en items[]
   * (ItemPromocionWeb), resueltos acá contra el catálogo cargado.
   */
  async asignarPromociones() {
    this.promocionesEcommerce.sort(this.ordenarPromos);
    const catalogo = this.sucursalesService.getSucursalActiva()?.articulos || [];
    this.promocionesEcommerce?.forEach(
      promo => {
        promo.resetArticulosItems();
        let resueltos = 0;
        promo.getItemsData().forEach((item) => {
          const articulo = catalogo.find(
            a => a.getMarca() == item.marca && a.getCodigo() == item.codigo
          );
          if (!articulo) {
            return;
          }
          promo.agregarArticuloItem(articulo as ArticulosEcommerce);
          // articulo1/2 van al primer/segundo item que efectivamente resolvió
          // contra el catálogo (no al índice 0/1 crudo de items[]): con
          // promos de Categoria, que pueden traer muchos artículos, si el
          // primero de la lista está deshabilitado o no sincronizado no debe
          // tumbar articulo1 para toda la promo.
          if (resueltos === 0) {
            promo.setArticulo1(articulo as ArticulosEcommerce);
          }
          if (resueltos === 1) {
            promo.setArticulo2(articulo as ArticulosEcommerce);
          }
          resueltos++;
          articulo.setPromo(promo);
          const promos = articulo.getPromos() as PromocionesEccomerce[];
          promos.sort(this.ordenarPromos);
        });
      }
    )
  }

  ordenarPromos = (a: PromocionesEccomerce, b: PromocionesEccomerce): number => {
    if (a.getOrden() > b.getOrden()) {
      return 1;
    }
    if (a.getOrden() < b.getOrden()) {
      return -1;
    }
    return 0;
  }

  getPromocionesEcommerce() {
    return this.promocionesEcommerce
  }

  getArticulosDePromociones() {
    let articulosDepromociones: ArticulosGeneral[] = []
    this.promocionesEcommerce.forEach(
      promocion => {
        if (promocion.getArticulo1() != undefined) {
          articulosDepromociones.push(promocion.getArticulo1());
        }
      }
    )
    //console.log('getArticulosDePromociones', articulosDepromociones)
    return articulosDepromociones;
  }

  /**
   * Devuelve la porción de 30 elementos de `fuente` correspondiente a `pagina` (0-indexed).
   */
  private paginarArray(fuente: ArticulosGeneral[], pagina: number): ArticulosGeneral[] {
    const paginado: ArticulosGeneral[] = [];
    for (let index = pagina * 30; index < (pagina + 1) * 30; index++) {
      if (fuente[index] != undefined) {
        paginado.push(fuente[index]);
      }
    }
    return paginado;
  }

  cambiarPagina(event: number) {
    this.paginaActual = event;
    this.lastSearch.next(this.paginarArray(this.resultadosDebusqueda, this.paginaActual));
  }

  cambiarPaginaOferta(event: number) {
    this.paginaActualOfertas = event;
    this.lastSearch.next(this.paginarArray(this.ofertas, this.paginaActualOfertas));
  }

  getPaginas() {
    return this.paginadorProvider.asObservable();
  }

  getPaginasOfertas() {
    return this.paginadorProviderOfertas.asObservable();
  }

  getArrayPaginas(paginas: any[]) {
    this.misPaginas = paginas;
  }

  getPaginaEmitter(emitter: EventEmitter<number>) {
    this.paginaEmitter = emitter;
  }

  cambiarPaginaElegida() {
    this.paginaElegida = {
      nombre: '1',
      numero: 0,
      activa: true
    }

    if (this.paginaEmitter !== undefined) {
      let pagine = 0;
      let index = 0;
      this.misPaginas.forEach(k => {
        k.activa = false;
        if (this.paginaElegida.numero == k.numero) {
          k.activa = true;
          pagine = index;
        }
        index++;
      });
      return this.paginaEmitter.emit(this.paginaElegida.numero);
    }
  }

  filtrarTag(tag: TagsEcommerce) {
    if (!this.tagsActivos.has(-100)) {
      this.tagsActivos.set(-100, this.resultadosDebusqueda)
    }
    let refiltrado: ArticulosGeneral[] = [];
    this.resultadosDebusqueda.forEach(k => {
      for (let tags of k.getTag()) {
        if (tags.tag == tag.tag) {
          refiltrado.push(k);
          break;
        }
      }
    });
    this.tagsActivos.set(tag.tag, refiltrado);
    this.resultadosDebusqueda = refiltrado;
    this.paginado();
  }

  cerrartag(tag: TagsEcommerce) {
    let tasact: number[] = [];
    let refiltrado: ArticulosGeneral[] = [];
    this.tagsActivos.forEach((art, tagnum) => {
      if (tag.tag == tagnum) {
        if (tag.selecionado) {
          tasact.push(tag.tag);
        }
      }
    });

    this.tagsActivos.get(-100).forEach(art => {
      art.getTag().forEach(tagArt => {
        tasact.forEach(tagsActivos => {
          if (tagArt.tag == tagsActivos) {
            refiltrado.push(art)
          }
        })
      })
    })
    if (tasact.length == 0) {
      this.resultadosDebusqueda = this.tagsActivos.get(-100);
    }
    else {
      this.resultadosDebusqueda = refiltrado;
    }
    this.paginado();
  }

  /**
   * Repite la busqueda por categoria activa, si la hay. Usar al terminar de cargar articulos/carrito
   * para no perder la categoria elegida mientras cargaba.
   * @returns true si habia una categoria activa y se repitio la busqueda
   */
  repetirBusquedaCategoria(): boolean {
    if (!this.ultimaBusquedaCategoria) {
      return false;
    }
    const { categoria, categoriaPadre } = this.ultimaBusquedaCategoria;
    this.busquedaCategoria(categoria, categoriaPadre);
    return true;
  }

  iniciarbusqueda(palabraBusqueda: string) {
    this.ultimaBusquedaCategoria = null;
    let myBusquedaExtras: ResultadosDeBusquedaInterface = {
      totaldeArticulos: 0,
      textodebusqueda: palabraBusqueda,
      tagsEnbusqueda: new Map(),
    };
    let contador = 0;
    this.paginaActual = 0;
    this.fueBusquedaEscrita = true;
    this.resultadosDebusqueda = [];
    let minirsultados: ArticulosGeneral[] = [];
    this.articulos2 = [];
    if (palabraBusqueda.length > 1) {
      const resultadosSet = new Set<ArticulosGeneral>();

      this.sucursalesService.getSucursalActiva()?.articulos?.forEach(articulo => {
        const coincideDescripcion = String(articulo.getDescripCion() || '').toLocaleLowerCase().includes(palabraBusqueda.toLocaleLowerCase()) || false;;
        const coincideNombreRubro = String(articulo.getNombreRubro() || '').toLocaleLowerCase().includes(palabraBusqueda.toLocaleLowerCase()) || false;;
        const coincideNombreFamilia = String(articulo.getNombreFamilia() || '').toLocaleLowerCase().includes(palabraBusqueda.toLocaleLowerCase()) || false;;
        const coincideMarca = String(articulo.getNombreMarca() || '').toLocaleLowerCase().includes(palabraBusqueda.toLocaleLowerCase()) || false;;

        if (coincideDescripcion || coincideNombreRubro || coincideNombreFamilia || coincideMarca) {
          
          resultadosSet.add(articulo);

          articulo.getTag().forEach(tag => {
            this.tags.forEach(tagreal => {
              tagreal.selecionado = false;
              if (tag.tag === tagreal.tag && !myBusquedaExtras.tagsEnbusqueda.has(tagreal.tag)) {
                myBusquedaExtras.tagsEnbusqueda.set(tagreal.tag, tagreal);
              }
            })
          })

          if (contador < 7) {
            minirsultados.push(articulo);
          }
          contador++;
          myBusquedaExtras.totaldeArticulos++;
        }
      });
      this.resultadosDebusqueda = Array.from(resultadosSet).sort((a, b) =>
        a.getDescripCion().localeCompare(b.getDescripCion()));
      //console.log("Estoy en el buscador esto es el resultado: ", this.resultadosDebusqueda);

      this.numBusqueda = this.resultadosDebusqueda.length;
      this.resultadosDebusquedaOriginales = this.resultadosDebusqueda;
      myBusquedaExtras.totaldeArticulos = this.numBusqueda;

      this.minisearch.next(minirsultados);
      this.paginado();
      this.resultadoDeBusquedaSubject.next(myBusquedaExtras);
      this.seRealizoUnaBusquedaSubject.next('se hizo busqueda')

    }
    else {
      if (palabraBusqueda === '' && this.sucursalesService.getSucursalActiva()?.articulos) {

        this.resultadosDebusqueda = this.sucursalesService.getSucursalActiva().articulos.slice();
        this.resultadosDebusqueda = this.busquedaPorNombre()
        this.numBusqueda = this.resultadosDebusqueda.length;
        this.resultadosDebusquedaOriginales = this.resultadosDebusqueda

      }

      this.paginado();
      this.resultadoDeBusquedaSubject.next({
        totaldeArticulos: 0,
        textodebusqueda: '',
      });
    }
  }

  busquedaPorNombre() {
    var sort = this.resultadosDebusqueda.sort((a, b) => (a.getDescripCion() > b.getDescripCion()) ? 1 : ((b.getDescripCion() > a.getDescripCion()) ? -1 : 0))
    var newSort = [];
    var oldSort = [];
    var flagSort = false;
    var arrFlag = [];

    this.busqueda = this.busqueda.toUpperCase();
    let arrBusqueda = this.busqueda.split("");
    sort.forEach(
      element => {
        let arrStr = element.getDescripCion().split(" ");
        arrFlag = [];
        for (let i = 0; i < arrBusqueda.length; i++) {
          const element2 = arrBusqueda[i];
          if (element2 === arrStr[0][i]) {
            flagSort = true;
            arrFlag.push(flagSort);
          }
          else {
            flagSort = false;
            arrFlag.push(flagSort);
          }
        }
        for (let i = 0; i < arrFlag.length; i++) {
          const flag = arrFlag[i];
          if (!flag) {
            flagSort = false;
          }
        }

        if (flagSort) {
          newSort.push(element);
        }
        else {
          oldSort.push(element);
        }
      }
    );
    for (let i = 0; i < oldSort.length; i++) {
      const element = oldSort[i];
      newSort.push(element);
    }

    return newSort;

  }

  paginado() {
    const paginas = this.resultadosDebusqueda.length / 30;
    this.paginadorProvider.next(paginas);
    this.paginaActual = 0;
    this.lastSearch.next(this.paginarArray(this.resultadosDebusqueda, 0));
  }

  paginadoSuc() {
    this.resultadosDebusqueda.sort(this.ordenAlfabetico);
    this.paginado();
    this.filterOn = true;

    this.lastSearch.next(this.lastSearch.value);
  }

  getAnchoPagina(ancho: number) {
    this.anchoPagina = ancho;
    return ancho;
  }

  private obtenerTodosLosIdsDeCategorias(categoria: CategoriasWebMenu, ids: number[] = []): number[] {
    if (!categoria) return ids;
    if (categoria.categoria != undefined) {
      ids.push(Number(categoria.categoria));
    }
    if (categoria.subCategorias && categoria.subCategorias.length > 0) {
      categoria.subCategorias.forEach(sub => this.obtenerTodosLosIdsDeCategorias(sub, ids));
    }
    return ids;
  }

  private collectArticlesFromCategories(categoria: CategoriasWebMenu): ArticulosGeneral[] {
    const allCategoryIds = this.obtenerTodosLosIdsDeCategorias(categoria);
    const newArticulos: ArticulosGeneral[] = [];
    const fecha = new Date().toISOString().split('T')[0];
    
    // 1. Recolectar todos los pares marca-codigo únicos de las categorías buscadas
    const uniqueKeys = new Set<string>();
    const markCodes: {marca: number, codigo: number}[] = [];

    allCategoryIds.forEach(id => {
      // Intentamos obtener artículos probando ambos tipos (number y string) para máxima compatibilidad
      const items = this.mapaPedidos?.get(id) || (this.mapaPedidos as any)?.get(id.toString());
      if (items) {
        items.forEach(item => {
          const key = `${item.marca}-${item.codigo}`;
          if (!uniqueKeys.has(key)) {
            uniqueKeys.add(key);
            markCodes.push(item);
          }
        });
      }
    });

    if (markCodes.length === 0 || !this.sucursalesService.getSucursalActiva()?.articulos) return [];

    // 2. Crear un índice rápido de los artículos de la sucursal activa para búsqueda O(1)
    const branchArticlesMap = new Map<string, ArticulosGeneral>();
    this.sucursalesService.getSucursalActiva().articulos.forEach(art => {
      branchArticlesMap.set(`${art.getMarca()}-${art.getCodigo()}`, art);
    });

    // 3. Cruzar datos de forma eficiente
    markCodes.forEach(item => {
      const art = branchArticlesMap.get(`${item.marca}-${item.codigo}`);
      if (art) {
        if (art.isdeoferta) {
          if (art.deOferta.fechahasta >= fecha) {
            newArticulos.push(art);
          }
        } else {
          newArticulos.push(art);
        }
      }
    });

    return newArticulos;
  }

  async busquedaCategoria(categoria: CategoriasWebMenu, categoriaPadre: CategoriasWebMenu) {
    let myBusquedaExtras: ResultadosDeBusquedaInterface = {
      totaldeArticulos: 0,
      textodebusqueda: categoria.nombre,
      categoria: categoriaPadre,
    };
    this.paginaActual = 0;
    this.fueBusquedaEscrita = false;
    this.numBusqueda = 0;

    this.ultimaBusquedaCategoria = { categoria, categoriaPadre };

    this.resultadosDebusqueda = this.collectArticlesFromCategories(categoria);
    this.resultadosDebusquedaOriginales = this.resultadosDebusqueda;
    this.numBusqueda = this.resultadosDebusqueda.length;
    myBusquedaExtras.totaldeArticulos = this.numBusqueda;

    this.paginado();
    this.resultadoDeBusquedaSubject.next(myBusquedaExtras);
  }

  async iniciarbusquedaPorCodigoMarca(categoria: CategoriasWebMenu, categoriaPadre: CategoriasWebMenu) {
    this.ultimaBusquedaCategoria = null;
    let myBusquedaExtras: ResultadosDeBusquedaInterface = {
      totaldeArticulos: 0,
      textodebusqueda: categoria.nombre,
      categoria: categoriaPadre,
    };
    this.paginaActual = 0;
    this.fueBusquedaEscrita = false;
    this.numBusqueda = 0;

    this.resultadosDebusqueda = this.collectArticlesFromCategories(categoria);
    this.numBusqueda = this.resultadosDebusqueda.length;
    myBusquedaExtras.totaldeArticulos = this.numBusqueda;

    this.paginado();
    this.resultadoDeBusquedaSubject.next(myBusquedaExtras);
  }
  //marca es parte de la pk del artículo, marcareal es un campo dedicado para que sea facil de cambiar y generar familias de productos para ofertas o similar,
  //si no realiza búsqueda revisar si artículos tienen marcareal seteada
  async busquedaPorMarca(categoria: CategoriasWebMenu) {
    this.ultimaBusquedaCategoria = null;
    if (!this.sucursalesService.getSucursalActiva()?.articulos) {
      return
    }
    console.log('busquedaxmarca categoria', categoria)
    let myBusquedaExtras: ResultadosDeBusquedaInterface = {
      totaldeArticulos: 0,
      textodebusqueda: categoria.nombre
    };
    let fecha = new Date();
    let newArticulos = [];
    this.paginaActual = 0;
    this.fueBusquedaEscrita = false;
    this.resultadosDebusqueda = [];
    this.numBusqueda = 0;
    this.sucursalesService.getSucursalActiva()?.articulos?.forEach(k => {
      if (k.marcareal == categoria.marca) {
        if (k.getMarcaReal() == k.marcareal && k.getCodigo() == k.codigo) {
          if (k.isdeoferta === true && k.deOferta.fechahasta > fecha.toISOString().split('T')[0]) {
            newArticulos.push(k);
          }
          if (k.isdeoferta === false) {
            newArticulos.push(k);
          }
          this.resultadosDebusqueda = newArticulos;

          if (this.resultadosDebusqueda.length === 0) {
            myBusquedaExtras.totaldeArticulos;
          }
          else {
            myBusquedaExtras.totaldeArticulos++;
          }
        }
      }
    })
    console.log('busquedaxmarca resultados de busqueda', this.resultadosDebusqueda)
    this.numBusqueda = this.resultadosDebusqueda.length;
    myBusquedaExtras.totaldeArticulos = this.numBusqueda;
    this.resultadosDebusquedaOriginales = this.resultadosDebusqueda;
    let paginado: ArticulosGeneral[] = [];
    let paginas = this.resultadosDebusqueda.length / 30;
    this.paginadorProvider.next(paginas);
    if (paginas > 1) {
      for (let index = 0; index < 30; index++) {
        paginado.push(this.resultadosDebusqueda[index]);
      }
      this.paginaActual = 0;
    }
    else {
      paginado = this.resultadosDebusqueda;
      this.paginaActual = 0;
    }
    this.lastSearch.next(paginado);
    this.resultadoDeBusquedaSubject.next(myBusquedaExtras);
  }

  getNumBusqueda() {
    return this.numBusqueda;
  }

  generarid(dimencion: number): string {
    let result = '';
    let characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
    let charactersLength = characters.length;
    for (let i = 0; i < dimencion; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  getUsuarioProvider() {
    return this.authService.getUserProvider();
  }

  getSucursalesProvider() {
    return this.sucursalesService.getSucursalesProvider();
  }

  getActualSucursal() {
    return this.sucursalesService.getSucursalActivaProvider();
  }

  getLastSearchProvider() {
    return this.lastSearch.asObservable();
  }

  getMiniSearchProvider() {
    return this.minisearch.asObservable();
  }

  getSucursalActiva() {
    return this.sucursalesService.getSucursalActiva();
  }

  getSucursales(): SucursalEcommerce[] {
    return this.sucursalesService.getSucursales();
  }

  getFueBusquedaEscrita() {
    return this.fueBusquedaEscrita;
  }

  getGenericoSeguro(params: HttpParams, ruta: string) {
    this.restartInactivityCheck()
    let environment = localStorage.getItem('environment')
    let user = JSON.parse(localStorage.getItem('currentUser'))

    if (this.environmenturl != undefined) {
      return this.httpClient.get(this.environmenturl.toString() + ruta, {
        headers: { "Authorization": this.authService.getUser() ? this.authService.getUser().token : '' }, params


      });
    } else {
      return this.httpClient.get(environment + ruta, {
        headers: { "Authorization": user ? user.token : '' }, params


      });
    }
  }

  postGenericoSeguro(url: string, body: object) {

    this.restartInactivityCheck()
    return this.httpClient.post(this.environmenturl + url, body, {
      headers: { "Authorization": this.authService.getUser() ? this.authService.getUser().token : '' }


    });
  }

  putGenericoSeguro(url: string, body: object) {
    this.restartInactivityCheck()
    return this.httpClient.put(this.environmenturl + url, body, {
      headers: { "Authorization": this.authService.getUser() ? this.authService.getUser().token : '' }


    });
  }

  /**
   * Carga los articulos del pedido en historial al 'carrito' actual
   * @param pedidoAnterior
   */
  cargarEstePedidoDeHistorialEnCart(pedidoAnterior: HistorialPedidos) {
    // Vaciamos cantidades/promos del carrito actual antes de recargarlo con
    // los items del pedido anterior, para que "Repetir Compra" no se sume
    // sobre lo que ya hubiera en el carrito. No usamos resetEccomerce() acá
    // porque además dispara un reset de búsqueda y una recarga async de
    // promociones que no queremos en este flujo.
    this.sucursalesService.getSucursalActiva().articulos.forEach(
      (articulo: ArticulosEcommerce) => this.eliminarPromos(articulo)
    );
    pedidoAnterior.items.forEach(
      (artEnPedido: BackUptArticulo) => {
        this.sucursalesService.getSucursalActiva().articulos.forEach(
          (articulo: ArticulosEcommerce) => {
            if (artEnPedido.codigo === articulo.getCodigo() && artEnPedido.marca === articulo.getMarca()) {
              articulo.agregarCantidad(artEnPedido.cantidad);
              this.tienePromoArticulo(articulo).forEach(
                (promocion: PromocionesEccomerce) => {
                  articulo.setPromo(promocion);
                })
              articulo.operacionesExtras();
            }
          }
        );
      }
    );
    this.sincronizarCarritoFrontyBack();
  }

  getHistorialDePedidos() {
    let httparams = new HttpParams();
    if (!this.pendingPedidos) {
      this.pendingPedidos = true;
      return this.getGenericoSeguro(httparams, 'pedidoweb').pipe(
        tap(data => {
          this.pendingPedidos = false;
          this.pedidosService.setHistorial(data['registros'] || []);

        for (let pedido of this.pedidosService.getHistorial()) {
          pedido.myitemsdetalle = [];
          pedido.itemsreales = [];

          if (pedido.monto != 0) {

            for (let itemRaw of pedido.items) {
              // 1. DETECCIÓN DE FLETE
              if (Number(itemRaw.marca) === Number(this.marcaFlete) && Number(itemRaw.codigo) === Number(this.codigoFlete)) {
                let fleteArt = this.crearArticuloFlete({
                  monto: itemRaw.monto,
                  descripcion: itemRaw.descripcion || 'FLETE A DOMICILIO', //descripción original si existe
                  presentacion: 'COSTO DE ENVIO',
                  etiqueta: 'FLETE'
                });
                pedido.myitemsdetalle.push(fleteArt);
                pedido.itemsreales.push(fleteArt);
                continue;
              }

              let articuloEncontradoEnSucursal = this.sucursalesService.getSucursalActiva().articulos.find(art =>
                art.getCodigo() == itemRaw.codigo && art.getMarca() == itemRaw.marca
              );

              if (articuloEncontradoEnSucursal) {

                let articuloCopy = new ArticulosEcommerce(
                  articuloEncontradoEnSucursal.getMarca(),
                  articuloEncontradoEnSucursal.getCodigo(),
                  itemRaw.precio,
                  0,
                  itemRaw.precio,
                  articuloEncontradoEnSucursal.getCantidadMaxima(),
                  articuloEncontradoEnSucursal.getDescripcionAdicional(),
                  itemRaw.descripcion,
                  0,
                  articuloEncontradoEnSucursal.getPresentacion(),
                  0,
                  0,
                  0,
                  '0', '0', '0',
                  0, 0, 0,
                  articuloEncontradoEnSucursal.getMarcaReal(),
                  '', 0, 0,
                  articuloEncontradoEnSucursal.getOtrosPrecios(),
                  articuloEncontradoEnSucursal.getFotoImagen(),
                  -1, [], false,
                  itemRaw.cantidad,
                  itemRaw.fraccion
                );
                articuloCopy.setCantidad(itemRaw.cantidad);
                if (articuloEncontradoEnSucursal.getImgDownload()) {
                  articuloCopy.setImgDownload(articuloEncontradoEnSucursal.getImgDownload());
                  articuloCopy.setFoto(articuloEncontradoEnSucursal.getFotoImagen());
                }
                pedido.myitemsdetalle.push(articuloCopy);
                pedido.itemsreales.push(articuloCopy);
              }
              else {
                // 3. PRODUCTO NO ENCONTRADO (Fallback genérico si el producto se borró de la sucursal)
                // Usamos una imagen genérica o vacía
                let imgenurl = new URL("/assets/logo/promo.png", this.environmenturl).toString();
                let articuloGenerico = new ArticulosEcommerce(
                  itemRaw.marca,
                  itemRaw.codigo,
                  itemRaw.precio,
                  0,
                  itemRaw.precio,
                  0,
                  "",
                  itemRaw.descripcion,
                  0,
                  "",
                  0, 0, 0,
                  '0', '0', '0',
                  itemRaw.cantidad,
                  0, 0,
                  itemRaw.marca,
                  '', 0, 0,
                  imgenurl,
                  "", -1, [], false,
                  itemRaw.cantidad,
                  itemRaw.fraccion
                );
                articuloGenerico.setCantidad(itemRaw.cantidad);
                articuloGenerico.setImgDownload(articuloGenerico.getImgDownload());
                articuloGenerico.setFoto(articuloGenerico.getFotoImagen());

                pedido.myitemsdetalle.push(articuloGenerico);
                pedido.itemsreales.push(articuloGenerico);
              }
            }
          } else {

            this.pedidosService.setHistorial(this.pedidosService.getHistorial().filter((item) => item.monto !== 0));
          }
        }
          this.pedidosService.emitHistorialActual();
        }),
        catchError(err => {
          this.pendingPedidos = false;
          console.error('Error al obtener historial:', err);
          return throwError(() => err);
        }),
        finalize(() => {
          this.pendingPedidos = false;
        })
      );
    } else {
      return of(this.pedidosService.getHistorial());
    }
  }

  obtenerHistorialDePedidosCargados(): HistorialPedidos[] {
    return this.pedidosService.getHistorial();
  }

  tienePromoArticulo(artreal: ArticulosGeneral): PromocionesEccomerce[] {
    let mispromos: PromocionesEccomerce[] = [];

    if (artreal.getPromos().length > 0) {
      return [];
    }

    this.promocionesEcommerce.forEach(promo => {
      // Recorre todos los renglones de items[] (no sólo articulo1/articulo2) para
      // que las promos con muchos artículos (ej. Porcentaje por Categoria) también
      // se reasignen bien al restaurar un carrito offline o desde el historial.
      const matchaAlgunItem = promo.getItemsData().some(
        item => item.codigo == artreal.getCodigo() && item.marca == artreal.getMarca()
      );
      if (matchaAlgunItem) {
        mispromos.push(promo);
      }
    })
    return mispromos;
  }

  getHistorialProvider() {
    return this.pedidosService.getHistorialProvider();
  }

  getGenerico(params: HttpParams, ruta: string) {
    this.restartInactivityCheck()
    return this.httpClient.get(this.environmenturl.toString() + ruta, {
      headers: { "Cache-Control": "max-age=10800" }, params
    });
  }

  postGenerico(url: string, body: object) {
    this.restartInactivityCheck()
    return this.httpClient.post(this.environmenturl.toString() + url, body);
  }

  putGenerico(url: string, body: object) {
    this.restartInactivityCheck()
    return this.httpClient.put(this.environmenturl.toString() + url, body);
  }

  loginPost(url: string, body: object) {
    return this.httpClient.post(this.environment.endpoint + url, body);
  }

  setmailAtencionAlCliente(mail: string) {
    this.mailAtencionAlCliente = mail
  }

  getmailAtencionAlCliente(): string {
    return this.mailAtencionAlCliente
  }

  settelefonoAtencionAlCliente(telefono: string) {
    this.telefonoAtencionAlCliente = telefono;
  }
  getDataEmpresa() {
    return this.dataEmpresa;
  }
  getworkWithA() {
    return this.workWithAs;
  }
  getEnvioExpress() {
    return this.envioExpress;
  }
  getinfoProv() {
    return this.infoProv;
  }
  getretiroSucursal() {
    return this.retiroSucursal;
  }
  getinfoCompra() {
    return this.infoCompra;
  }
  getinfoMP() {
    return this.infoMP;
  }

  getObservacionesEnvios() {
    return this.observacionesEnvio;
  }

  getTextoCerrarPedido() {
    return this.textoCerrarPedido;
  }

  getTerminosCondiciones() {
    return this.terminos_condiciones;
  }
  getInformacionEnvio() {
    return this.informacion_envio;
  }
  getPoliticaDevoluciones() {
    return this.politica_devoluciones;
  }

  gettelefonoAtencionAlCliente(): string {
    return this.telefonoAtencionAlCliente;
  }

  getNumeroWhatsapp(): string {
    const telefonoSucursal = this.sucursalesService.getSucursalActiva()?.telefono;
    if (telefonoSucursal) {
      return telefonoSucursal;
    }

    if (this.numeroWhatsapp) {
      return this.numeroWhatsapp;
    }

    const redWhatsapp = this.redes.find(red => (red.nombre || '').toLowerCase().includes('whatsapp'));
    const digitos = (redWhatsapp?.link || '').replace(/[^\d]/g, '');
    return digitos || '';
  }

  getSeRealizoUnaBusquedaObservable() {
    return this.seRealizoUnaBusquedaObservable;
  }

  getReemplazos() {
    return this.remplazos;
  }

  getObservableSeAgregaronItemsAlCarrito() {
    return this.seAgregaronArtículosAlCarrito.asObservable()
  }

  getAvisoArticulosSucursalCargados() {
    return this.articulosSucursalCargados.asObservable()
  }

  getsincronizandoCarritoConBack() {
    return this.sincronizandoCarritoConBack
  }

  getMenuWatermarkMensaje() {
    return this.menuWatermarkMensaje;
  }

  getMarcadeagua() {
    return this.marcadeagua;
  }

  getOpacidadMarcadeagua() {
    return this.opacidad_marcadeagua;
  }

  getLogoEmpresa() {
    return this.logo_empresa;
  }

  getResultadoDeBusquedaProvider() {
    return this.resultadoDeBusquedaSubject.asObservable();
  }
  enviarArrepentimiento(datos: { nombre: string, email: string, pedido: string, mensaje: string }) {
    return this.postGenericoSeguro('enviar_arrepentimiento', datos);
  }

  setArticuloObservacion(articulo: ArticulosEcommerce): void {
    this.articuloObservacion = articulo;
  }

  getArticuloObservacion(): ArticulosEcommerce {
    return this.articuloObservacion;
  }

  private mismoArticulo(articuloBackup: any, articulo: ArticulosEcommerce): boolean {
    return Number(articuloBackup.marca) === Number(articulo.getMarca()) &&
      Number(articuloBackup.codigo) === Number(articulo.getCodigo());
  }

  /**
   * Compara el backup de carrito offline (en memoria) contra el carrito ya persistido en el servidor.
   * Se usan para detectar si realmente hay algo para combinar o si el backup es solo un reflejo
   * redundante del mismo carrito ya sincronizado (evita duplicar cantidades al combinar).
   */
  private carritosOfflineYWebSonIguales(offline: BackUptArticulo[], web: BackUptArticulo[]): boolean {
    if (offline.length !== web.length) {
      return false;
    }
    const bultosDe = (item: BackUptArticulo) => Number(
      item.bultos ?? (item as any).cantidadbultos ?? (item as any).cantidadBultos ?? 0
    );
    return offline.every(itemOffline =>
      web.some(itemWeb =>
        Number(itemOffline.marca) === Number(itemWeb.marca) &&
        Number(itemOffline.codigo) === Number(itemWeb.codigo) &&
        Number(itemOffline.cantidad || 0) === Number(itemWeb.cantidad || 0) &&
        bultosDe(itemOffline) === bultosDe(itemWeb)
      )
    );
  }
  
  /**
   * Trae solo las URL de imagen de los artículos. articulosweb queda cacheado en el backend
   * (tempJSON + caché de la petición) y una foto nueva tardaba horas en verse; fotosarticulosweb
   * no tiene caché. Si falla (ej. backend sin la petición nueva) se siguen usando las fotos de articulosweb.
   */
  private obtenerFotosArticulos(): Observable<any[]> {
    return this.getGenerico(new HttpParams(), 'fotosarticulosweb').pipe(
      map(data => (data && Array.isArray(data['registros'])) ? data['registros'] : []),
      catchError(() => of([]))
    );
  }

  private aplicarFotosArticulos(registros: any[], fotos: any[]): any[] {
    if (!fotos.length) {
      return registros;
    }
    const fotoPorArticulo = new Map<string, string>();
    fotos.forEach(f => fotoPorArticulo.set(`${f.marca}_${f.codigo}`, f.foto));
    registros.forEach(registro => {
      const foto = fotoPorArticulo.get(`${registro.marca}_${registro.codigo}`);
      if (foto) {
        registro.foto = foto;
      }
    });
    return registros;
  }

  private obtenerArticulosCrudosPorLista(sucursal: string, lista: number = 0): Observable<any[]> {
    const listaFinal = Number(lista || 0);
    const key = `${sucursal}_${listaFinal}`;
  
    if (this.cacheArticulosPorLista.has(key)) {
      const cache = this.cacheArticulosPorLista.get(key) || [];
      console.log('usando caché artículos:', key, cache.length);

      console.table(cache.slice(0, 20).map((art: any) => ({
        marca: art.marca,
        codigo: art.codigo,
        descripcion: art.descripcion,
        precio: art.precio,
        precionormal: art.precionormal,
        eslistamayorista: art.eslistamayorista
      })));

      return of(cache);
    }
  
    let params = new HttpParams();
    params = params.append('sucursal', sucursal);
    params = params.append('lista', listaFinal);
  
    return this.getGenerico(params, 'articulosweb').pipe(
      map(data => data['registros'] || []),
      tap(registros => {
        console.log('RECIBIDOS DEL BACK:', key, registros.length);

        console.table(registros.slice(0, 20).map((art: any) => ({
          marca: art.marca,
          codigo: art.codigo,
          descripcion: art.descripcion,
          precio: art.precio,
          precionormal: art.precionormal,
          eslistamayorista: art.eslistamayorista
        })));

        console.log('Cantidad en lista mayorista:', registros.filter((art: any) =>
          Number(art.eslistamayorista || 0) === 1
        ).length);
  
        console.log('Cantidad fuera de lista mayorista:', registros.filter((art: any) =>
          Number(art.eslistamayorista || 0) === 0
        ).length);

        this.cacheArticulosPorLista.set(key, registros);
      })
    );
  }

  puedePivotearListaCF(): boolean {
    return !!this.authService.getUser() &&
      Number(this.authService.getUser().listamayorista || 0) > 0 &&
      (this.authService.getUser().listareducmayorista || 'N').toString().trim() === 'N';
  }
  
  getTextoBotonListaCF(): string {
    return this.vistaListaActual === 'MAY' ? 'Ver lista CF' : 'Ver lista May';
  }
  
  alternarVistaListaMayoristaCF(): void {
    if (!this.puedePivotearListaCF()) {
      return;
    }
  
    this.vistaListaActual = this.vistaListaActual === 'MAY' ? 'CF' : 'MAY';
    this.aplicarVistaListaActual();
  }
  
  private getArticulosBaseVistaActual(): ArticulosGeneral[] {
    if (!this.sucursalesService.getSucursalActiva()?.articulos) {
      return [];
    }
  
    const articulos = this.sucursalesService.getSucursalActiva().articulos.slice();
  
    if (this.vistaListaActual === 'MAY') {
      return articulos.filter((articulo: any) =>
        Number(articulo.eslistamayorista || 0) === 1
      );
    }
  
    if (this.vistaListaActual === 'CF') {
      return articulos.filter((articulo: any) =>
        Number(articulo.eslistamayorista || 0) === 0
      );
    }
  
    return articulos;
  }
  
  private aplicarVistaListaActual(): void {
    const articulosVisibles = this.getArticulosBaseVistaActual();
  
    this.resultadosDebusqueda = articulosVisibles;
    this.resultadosDebusquedaOriginales = articulosVisibles;
    this.numBusqueda = articulosVisibles.length;
  
    this.paginado();
  
    console.log('Vista lista actual:', this.vistaListaActual, {
      puedePivotear: this.puedePivotearListaCF(),
      listaUsuario: this.authService.getUser()?.listamayorista,
      reducUsuario: this.authService.getUser()?.listareducmayorista,
      totalSucursal: this.sucursalesService.getSucursalActiva()?.articulos?.length,
      visibles: articulosVisibles.length,
      mayoristas: articulosVisibles.filter((art: any) => Number(art.eslistamayorista || 0) === 1).length,
      cf: articulosVisibles.filter((art: any) => Number(art.eslistamayorista || 0) === 0).length
    });
  }

  getVistaListaActual(): string {
    return this.vistaListaActual;
  }

}
